import { React, useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  RightLayoutContainer,
  PageTitleComp,
  DetailFields,
  DownArrowDraw,
  DropDownSearchDraw,
  TableLayoutData,
  // PaginationStyle
} from "../../styledElements";
import {
  Styled,
  DatePickerY,
  DisabledButtonStyle,
  GlobalSet,
} from "../../pageStyled";
import { DatePicker } from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import {
  Button,
  Row,
  Col,
  Form,
  Input,
  Select,
  PageHeader,
  Checkbox,
  Tooltip,
  Pagination,
} from "antd";
import { HaberForm } from "../../styledElements";
import { useWindowDimensions } from "../../../hooks/useWindowDimensions";
import {
  getProductDetails,
  getProductsData,
} from "../../../Services/productServices";
import {
  saveUploadedOrders,
  getPackagingList,
} from "../../../Services/orderServices";
import {
  getMachineGradeSelect,
  getReelCoreValues,
} from "../../../Services/settingsServices";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import moment from "moment";
import {
  calculatePlannedReels,
  calculatePlannedWeight,
  plannedReelsCalculations
} from "../../../Utils/helper/calculatePlannedWeight";
import styled from "styled-components";
import { FixedSizeList } from "react-window";
import AutoSizer from "react-virtualized-auto-sizer";
import { getUnitData } from "../../../Services/measurementService";
import {
  lengthUnit,
  weightUnit,
  weight_Unit_Conversions,
  orderDim_Rewinder_Unit_Conversion,
  currency_List,
  conversionFactorTonneToUnits,
} from "../../../Utils/Constant/MeasurementUnitList";
const capitalize = (item) => item?.charAt(0)?.toUpperCase() + item?.slice(1);
const UploadedOrdersData = (props) => {
  const location = useLocation();
  const history = useNavigate();
  const { height, width } = useWindowDimensions();
  const { Option } = Select;
  const [form] = Form.useForm();
  const [ordersForSelectedPo, setOrdersForSelectedPo] = useState(
    location.state.uploadedData
  );
  const [filteredOrders, setFilteredOrders] = useState(
    location.state.uploadedData.data.pos[location.state.selectedPoIndex].orders
  );
  const [ordersToShow, setOrdersToShow] = useState();
  const [poDataToSave, setPoDataToSave] = useState();
  const [orderWeightUnit, setOrderWeightUnit] = useState("");
  const [rerendering, setRerendering] = useState(false);
  const [products, setProducts] = useState([]);
  const [orderTypes, setOrderTypes] = useState([]);
  const [savedState, setSavedState] = useState(false);
  const [isProductDropdownOpen, setProductDropdown] = useState(false);
  const [productData, setProductData] = useState({
    bulk: "",
    gsm: "",
  });
  const [actionToaster, setActionToaster] = useState({
    error: "",
    msg: "",
  });
  const [visibleToaster, setVisibleToaster] = useState(false);
  const [show, setShow] = useState(false);
  const [defaultMixedGrain, setDefaultMixedGrain] = useState(false);
  const [upperTolerance, setUpperTol] = useState("");
  const [lowerTolerance, setLowerTol] = useState("");
  const [isVisible, setIsVisible] = useState(false);
  const [dimesionUnitList, setDimesionUnitList] = useState([]);
  const [measurementData, setMeasurementData] = useState();
  const [weightUnitList, setWeightUnitList] = useState([]);
  const [currencyUnitData, setCurrencyUnitData] = useState([]);
  const [reelPackagingData, setReelPackagingData] = useState([]);
  const [sheetPackagingData, setSheetPackagingData] = useState([]);
  const [otherButtonLoading, setOtherButtonLoadingLoadings] = useState(false);
  const [loadings, setLoadings] = useState(false);
  const [resendAppLoading, setResendApprovalLoading] = useState(false);
  const [resendAppOtherButtonLoading, setResendAppOtherButtonLoading] =
    useState(false);
  // const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [gobackLoading, setGobackLoading] = useState(false);
  // const listRef = useRef(null);
  const [reelvalues,setReelvalues] = useState([]);
  const [corevalues,setCoreValues] = useState([]);

  const plyData = [
    { label: "Single Ply", value: 1 },
    { label: "Double Ply", value: 2 },
    { label: "3-Ply", value: 3 },
    { label: "4-Ply", value: 4 },
  ];

  const OrderSummary = styled.div`
  .orderSummaryStyle {
    display: block;
    padding-bottom: 16px;
    font-size: 12px;
    font-family: var(--sf-pro-display-m);
    color: black;
    font-style: italic,
    line-height: 16px;
  }
  .orderWeightStyle {
    margin-right: -10px;
  }
`;
  const rowCount = useRef(false);

  const OnProductToggleSelect = () => {
    setProductDropdown((prevState) => !prevState);
  };

  const onFinish = async () => {
    let dataToSave = poDataToSave.data;
    try {
      const response = await getReelCoreValues();
      if (!response.error) {
        for (let index = 0; index < dataToSave.pos[0].orders.length; index++) {
          let order = dataToSave.pos[0].orders[index].order;
          order["category"] = dataToSave.pos[0].po["po/so"];
          let productNo = order.product.split(" -");
          if (
            dataToSave.pos[0].po["po/so"] === "so" &&
            dataToSave.pos[0].po.number
          ) {
            dataToSave.pos[0].po["reference_number"] =
              dataToSave.pos[0].po.number;
          }
          if (dataToSave.pos[0].po["po/so"] === "so") {
            order.po = "";
            order.delivery_date = null;
          }
          // await getProductDetails(productNo[0]).then((productResp) => {
          let productResp = products?.filter(
            (ele) => productNo[0] === ele.code
          );
          let coreIdUnit;
          let reelOdUnit;

          if(!order?.reel_od && !order?.core_id){
            if (
              order.type === "reel" &&
              response.default_reel_od &&
              response.default_core_id
            ) {
              if (order.type === "reel") {
                let widthData = (
                  order.width * orderDim_Rewinder_Unit_Conversion[order.size_unit]
                ).toFixed(3);
                let diaArr = [];
                order.reel_od = response.default_reel_od
                  ? response.default_reel_od
                  : 0;
                order.core_id = response.default_core_id
                  ? response.default_core_id
                  : 0;

                // let productNo = order.product.split(" -");
                // await getProductDetails(productNo[0]).then((productResp) => {
                if (
                  (order.outer_dia?.length && order.inner_dia) ||
                  (order.outer_dia?.length &&
                    (order.inner_dia == 0 || order.inner_dia == ""))
                ) {
                  coreIdUnit = response.default_reel_unit;
                  reelOdUnit = response.default_reel_unit;
                } else if (order.outer_dia?.length == 0 && order.inner_dia) {
                  coreIdUnit = response.default_core_unit;
                  reelOdUnit = response.default_core_unit;
                } else if (
                  order.outer_dia?.length == 0 &&
                  (order.inner_dia == 0 || order.inner_dia == "")
                ) {
                  coreIdUnit =
                    measurementData.data.units_management.length.default;
                  reelOdUnit =
                    measurementData.data.units_management.length.default;
                }

                order.reel_od_unit = reelOdUnit;
                order.core_id_unit = coreIdUnit;

                let outerDiaArr = [];
                outerDiaArr.push(response.default_reel_od + " " + reelOdUnit);
                order.outer_dia = response.default_reel_od ? outerDiaArr : diaArr;
                order.inner_dia = response.default_core_id
                  ? response.default_core_id + " " + coreIdUnit
                  : "";

                if (
                  order.type === "reel" &&
                  order.quantity_type === "reel_sheet" &&
                  order.no_of_reel_sheet
                ) {
                  order.quantity = order.no_of_reel_sheet;
                  order.weight_unit =
                    measurementData.data.units_management.weight.default;
                  order["planning_quantity"] = order.no_of_reel_sheet;
                } else {
                  let plannedReels = calculatePlannedReels(
                    parseFloat(widthData),
                    order.weight * weight_Unit_Conversions[order.weight_unit],
                    productResp[0].bulk,
                    order.outer_dia[0]?.split(" ")[0] *
                      orderDim_Rewinder_Unit_Conversion[reelOdUnit],
                    order.inner_dia?.split(" ")[0] *
                      orderDim_Rewinder_Unit_Conversion[coreIdUnit]
                  );
                  order.quantity = Math.round(parseFloat(plannedReels).toFixed(3))
                    ? Math.round((parseFloat(plannedReels) * 1).toFixed(3))
                    : 1;
                  order["planning_weight"] = order.weight;
                }
                let planned_weight = calculatePlannedWeight(
                  parseFloat(widthData),
                  productResp[0].bulk,
                  parseFloat(order.outer_dia[0]?.split(" ")[0]) *
                    orderDim_Rewinder_Unit_Conversion[reelOdUnit],
                  parseFloat(order.inner_dia?.split(" ")[0]) *
                    orderDim_Rewinder_Unit_Conversion[coreIdUnit],
                  order.quantity
                );
                let plannedWt =
                  planned_weight *
                  conversionFactorTonneToUnits[order.weight_unit];
                order.planned_weight = plannedWt
                  ? parseFloat(plannedWt).toFixed(3)
                  : 0;

                let plannedWtConversion;
                if (
                  productResp[0]?.units.per_weight_unit.toLowerCase() !==
                  order?.per_weight_unit.toLowerCase()
                ) {
                  order.per_weight_unit = productResp[0]?.units.per_weight_unit;
                }
                // if(order?.weight_unit?.toLowerCase() !== order?.per_weight_unit?.toLowerCase()){
                //   let unitToTonneConv = order.planned_weight * weight_Unit_Conversions[order?.weight_unit];
                //   plannedWtConversion  = unitToTonneConv * conversionFactorTonneToUnits[order?.per_weight_unit];
                // } else{
                //     plannedWtConversion  = order.planned_weight;
                // }
                // const netPrice = parseFloat(order.dealer_price) * parseFloat(plannedWtConversion)
                //       ? parseFloat(order.dealer_price) * parseFloat(plannedWtConversion)
                //       : "";
                let netPrice;
                if (order.quantity_type == "weight") {
                  netPrice =
                    parseFloat(order.dealer_price) *
                    parseFloat(order.weight)?.toFixed(3);
                }
                order.net_price = netPrice ? netPrice?.toFixed(3) : 0;
                order.quantity = Math.round(order.quantity);
              }
            } else if (order.type === "sheet") {
              let widthData = (
                order.width * orderDim_Rewinder_Unit_Conversion[order.size_unit]
              ).toFixed(3);
              let lengthData = (
                order.length * orderDim_Rewinder_Unit_Conversion[order.size_unit]
              ).toFixed(3);

              if (!order?.core_id) {
                order.core_id = response.default_core_id ? response.default_core_id : 0;
                if (!order.units.core_id_unit) {
                  order.units.core_id_unit = response.default_core_id
                    ? response.default_core_unit
                    : measurementData.data.units_management.default;
                }
                order.inner_dia = order.core_id + " " + (order?.units?.core_id_unit ? order?.units?.core_id_unit : order?.core_id_unit);
              }

              if (
                order.outer_dia?.length == 0 &&
                (order.inner_dia == 0 || order.inner_dia == "")
              ) {
                if (order.quantity_type === "reel_sheet") {
                  let widthValue = parseFloat(widthData);
                  let lengthValue = parseFloat(lengthData);
                  order.weight_unit =
                    measurementData.data.units_management.weight.default;
                  const plannedWeight =
                    (lengthValue *
                      widthValue *
                      order.no_of_reel_sheet *
                      productResp[0].gsm) /
                    (10000 * 1000000);
                  let plannedWt =
                    plannedWeight *
                    conversionFactorTonneToUnits[order.weight_unit];
                  order.planned_weight = plannedWt?.toFixed(3);
                  order["planning_quantity"] = order.no_of_reel_sheet;
                  // if(order.planned_weight){
                  //   let upperTol = (parseFloat(order.planned_weight)?.toFixed(3) * (100 + upperTolerance)) /100;
                  //   let lowerTol = (parseFloat(order.planned_weight)?.toFixed(3) * (100 - lowerTolerance)) /100;
                  //   // order.lower_tolerance = lowerTolerance;
                  //   // order.upper_tolerance = upperTolerance;
                  //   // order.calculated_lower_tolerance = lowerTol.toFixed(3);
                  //   // order.calculated_upper_tolerance = upperTol.toFixed(3);
                  // }else{
                  //   // order.lower_tolerance = lowerTolerance;
                  //   // order.upper_tolerance = upperTolerance;
                  //   // order.calculated_lower_tolerance = parseFloat(order.calculated_lower_tolerance)?.toFixed(3);
                  //   // order.calculated_upper_tolerance = parseFloat(order.calculated_upper_tolerance)?.toFixed(3);
                  // }
                } else {
                  order.weight = order.weight?.toFixed(3);
                  order.planned_weight = order.weight;
                  order["planning_weight"] = order.weight;
                  // if(order.planned_weight){
                  //   let upperTol = (parseFloat(order.planned_weight)?.toFixed(3) * (100 + upperTolerance)) /100;
                  //   let lowerTol = (parseFloat(order.planned_weight)?.toFixed(3) * (100 - lowerTolerance)) /100;
                  //   order.lower_tolerance = lowerTolerance;
                  //   order.upper_tolerance = upperTolerance;
                  //   // order.calculated_lower_tolerance = lowerTol.toFixed(3);
                  //   // order.calculated_upper_tolerance = upperTol.toFixed(3);
                  // }else{
                  //   order.lower_tolerance = lowerTolerance;
                  //   order.upper_tolerance = upperTolerance;
                  //   // order.calculated_lower_tolerance = order.calculated_lower_tolerance?.toFixed(3);
                  //   // order.calculated_upper_tolerance = order.calculated_upper_tolerance?.toFixed(3);
                  // }
                  delete order.no_of_reel_sheet;
                }
                let plannedWtConversion;
                if (
                  productResp[0]?.units.per_weight_unit.toLowerCase() !==
                  order?.per_weight_unit.toLowerCase()
                ) {
                  order.per_weight_unit = productResp[0]?.units.per_weight_unit;
                }
                if (
                  order?.weight_unit?.toLowerCase() !==
                  order?.per_weight_unit?.toLowerCase()
                ) {
                  let unitToTonneConv =
                    order.planned_weight *
                    weight_Unit_Conversions[order?.weight_unit];
                  plannedWtConversion =
                    unitToTonneConv *
                    conversionFactorTonneToUnits[order?.per_weight_unit];
                } else {
                  plannedWtConversion = order.planned_weight;
                }
                const netPrice =
                  parseFloat(order.dealer_price) * parseFloat(plannedWtConversion)
                    ? parseFloat(order.dealer_price) *
                      parseFloat(plannedWtConversion)
                    : "";
                order.net_price = netPrice ? netPrice?.toFixed(3) : 0;
              }
              order.quantity = Math.round(order.quantity);
            } else if (
              order.type === "reel" &&
              (!response.default_reel_od || !response.default_core_id)
            ) {
              if (order.type === "reel" && order.quantity_type === "reel_sheet") {
                order.quantity = order.no_of_reel_sheet;
                order.weight_unit =
                  measurementData.data.units_management.weight.default;
                order["planning_quantity"] = order.no_of_reel_sheet;
              } else {
                order.quantity = 0;
                order["planning_weight"] = order.weight;
              }
            }
          } else{
            // if sheet and core id but no reel od = it will work like !reel and !core id
            if (order?.type == "sheet" && !order?.reel_od && order?.core_id) {
              let widthData = (
                order.width * orderDim_Rewinder_Unit_Conversion[order.size_unit]
              ).toFixed(3);
              let lengthData = (
                order.length * orderDim_Rewinder_Unit_Conversion[order.size_unit]
              ).toFixed(3);

              if (
                order.outer_dia?.length == 0 &&
                (order.inner_dia == 0 || order.inner_dia == "")
              ) {
                order.inner_dia = order.core_id + " " + (order?.units?.core_id_unit ? order?.units?.core_id_unit : order?.core_id_unit);
                if (order.quantity_type === "reel_sheet") {
                  let widthValue = parseFloat(widthData);
                  let lengthValue = parseFloat(lengthData);
                  order.weight_unit =
                    measurementData.data.units_management.weight.default;
                  const plannedWeight =
                    (lengthValue *
                      widthValue *
                      order.no_of_reel_sheet *
                      productResp[0].gsm) /
                    (10000 * 1000000);
                  let plannedWt =
                    plannedWeight *
                    conversionFactorTonneToUnits[order.weight_unit];
                  order.planned_weight = plannedWt?.toFixed(3);
                  order["planning_quantity"] = order.no_of_reel_sheet;
                } else {
                  order.weight = order.weight?.toFixed(3);
                  order.planned_weight = order.weight;
                  order["planning_weight"] = order.weight;
                  delete order.no_of_reel_sheet;
                }
                let plannedWtConversion;
                if (
                  productResp[0]?.units.per_weight_unit.toLowerCase() !==
                  order?.per_weight_unit.toLowerCase()
                ) {
                  order.per_weight_unit = productResp[0]?.units.per_weight_unit;
                }
                if (
                  order?.weight_unit?.toLowerCase() !==
                  order?.per_weight_unit?.toLowerCase()
                ) {
                  let unitToTonneConv =
                    order.planned_weight *
                    weight_Unit_Conversions[order?.weight_unit];
                  plannedWtConversion =
                    unitToTonneConv *
                    conversionFactorTonneToUnits[order?.per_weight_unit];
                } else {
                  plannedWtConversion = order.planned_weight;
                }
                const netPrice =
                  parseFloat(order.dealer_price) * parseFloat(plannedWtConversion)
                    ? parseFloat(order.dealer_price) *
                    parseFloat(plannedWtConversion)
                    : "";
                order.net_price = netPrice ? netPrice?.toFixed(3) : 0;
              }
              order.quantity = Math.round(order.quantity);
            } else {
              if (!order?.reel_od) {
                order.reel_od = response.default_reel_od ? response.default_reel_od : 0;
                if (!order.units.reel_od_unit) {
                  order.units.reel_od_unit = response.default_reel_od
                    ? response.default_reel_unit
                    : measurementData.data.units_management.default;
                }
              }

              if (!order?.core_id) {
                order.core_id = response.default_core_id ? response.default_core_id : 0;
                if (!order.units.core_id_unit) {
                  order.units.core_id_unit = response.default_core_id
                    ? response.default_core_unit
                    : measurementData.data.units_management.default;
                }
              }

              let outerDiaArr = [];
              outerDiaArr.push(order?.reel_od + " " + (order?.units?.reel_od_unit ? order?.units?.reel_od_unit : measurementData.data.units_management?.length?.default));
              order.outer_dia = outerDiaArr;
              order.inner_dia = order.core_id + " " + (order?.units?.core_id_unit ? order?.units?.core_id_unit : measurementData.data.units_management?.length?.default);

              if (order.type === "reel") {
                let widthData = (
                  order.width * orderDim_Rewinder_Unit_Conversion[order.size_unit]
                ).toFixed(3);

                if (
                  order.type === "reel" &&
                  order.quantity_type === "reel_sheet" &&
                  order.no_of_reel_sheet
                ) {
                  order.quantity = order.no_of_reel_sheet;
                  order.weight_unit =
                    measurementData.data.units_management.weight.default;
                  order["planning_quantity"] = order.no_of_reel_sheet;
                } else {
                  let plannedReels = calculatePlannedReels(
                    parseFloat(widthData),
                    order.weight * weight_Unit_Conversions[order.weight_unit],
                    productResp[0].bulk,
                    order.outer_dia[0]?.split(" ")[0] *
                    orderDim_Rewinder_Unit_Conversion[order.units.reel_od_unit],
                    order.inner_dia?.split(" ")[0] *
                    orderDim_Rewinder_Unit_Conversion[order.units.core_id_unit]
                  );
                  order.quantity = Math.round(parseFloat(plannedReels).toFixed(3))
                    ? Math.round((parseFloat(plannedReels) * 1).toFixed(3))
                    : 1;
                  order["planning_weight"] = order.weight;
                }
                //calculate planned weight
                let planned_weight = calculatePlannedWeight(
                  parseFloat(widthData),
                  productResp[0].bulk,
                  parseFloat(order.outer_dia[0]?.split(" ")[0]) *
                  orderDim_Rewinder_Unit_Conversion[order.outer_dia[0]?.split(" ")[1]],
                  parseFloat(order.inner_dia?.split(" ")[0]) *
                  orderDim_Rewinder_Unit_Conversion[order.inner_dia?.split(" ")[1]],
                  order.quantity
                );
                let plannedWt =
                  planned_weight *
                  conversionFactorTonneToUnits[order.weight_unit];
                order.planned_weight = plannedWt
                  ? parseFloat(plannedWt).toFixed(3)
                  : 0;

                let plannedWtConversion;
                if (
                  productResp[0]?.units.per_weight_unit.toLowerCase() !==
                  order?.per_weight_unit.toLowerCase()
                ) {
                  order.per_weight_unit = productResp[0]?.units.per_weight_unit;
                }
                let netPrice;
                if (order.quantity_type == "weight") {
                  netPrice =
                    parseFloat(order.dealer_price) *
                    parseFloat(order.weight)?.toFixed(3);
                }
                order.net_price = netPrice ? netPrice?.toFixed(3) : 0;
                order.quantity = Math.round(order.quantity);

              } 
              // else if (order.type === "reel" && (!order?.reel_od || !order?.core_id)) {
              //   if (order.type === "reel" && order.quantity_type === "reel_sheet") {
              //     order.quantity = order.no_of_reel_sheet;
              //     order.weight_unit =
              //       measurementData.data.units_management.weight.default;
              //     order["planning_quantity"] = order.no_of_reel_sheet;
              //   } else {
              //     order.quantity = 0;
              //     order["planning_weight"] = order.weight;
              //   }
              // } else
              else{
                let size = 
                (order?.grain === "Long Grain" ||
                order?.grain === "long" ||
                order?.grain === "long grain"
                  ? parseFloat(order?.width) > parseFloat(order?.length)
                    ? order?.length
                    : order?.width
                  : parseFloat(order?.length) > parseFloat(order?.width)
                  ? order?.length
                  : order?.width);

                  let widthData = (
                  size * orderDim_Rewinder_Unit_Conversion[order.size_unit]
                ).toFixed(3);

                let quantityValue;
                let plannedReels;

                if(order?.quantity_type == "weight"){
                    quantityValue = order.weight * weight_Unit_Conversions[order.weight_unit];
                    plannedReels = plannedReelsCalculations(
                    parseFloat(widthData),
                    order?.length * orderDim_Rewinder_Unit_Conversion[order.size_unit],
                    order?.width * orderDim_Rewinder_Unit_Conversion[order.size_unit],
                    productResp[0].bulk,
                    productResp[0].gsm,
                    order.inner_dia?.split(" ")[0] * orderDim_Rewinder_Unit_Conversion[order?.units?.core_id_unit ? order?.units?.core_id_unit : order?.core_id_unit],
                    order.outer_dia[0]?.split(" ")[0] * orderDim_Rewinder_Unit_Conversion[order?.units?.reel_od_unit ? order?.units?.reel_od_unit : order?.reel_od_unit],
                    quantityValue,
                    order?.quantity_type
                  );
                  order.quantity = Math.round(parseFloat(plannedReels).toFixed(3))
                    ? Math.round((parseFloat(plannedReels) * 1).toFixed(3))
                    : 1;
                  order["planning_weight"] = order.weight;
                } else{
                  //in ordertype = sheet && quantity type = sheet ? order?.no_of_reel_sheet means user entered value and same in planning qty
                  // quantity = calculated reels
                  quantityValue = order.no_of_reel_sheet;
                    plannedReels = plannedReelsCalculations(
                    parseFloat(widthData),
                    order?.length * orderDim_Rewinder_Unit_Conversion[order.size_unit],
                    order?.width * orderDim_Rewinder_Unit_Conversion[order.size_unit],
                    productResp[0].bulk,
                    productResp[0].gsm,
                    order.inner_dia?.split(" ")[0] * orderDim_Rewinder_Unit_Conversion[order?.units?.core_id_unit ? order?.units?.core_id_unit : order?.core_id_unit],
                    order.outer_dia[0]?.split(" ")[0] * orderDim_Rewinder_Unit_Conversion[order?.units?.reel_od_unit ? order?.units?.reel_od_unit : order?.reel_od_unit],
                    quantityValue,
                    order?.quantity_type
                  );
                  order.quantity = Math.round(parseFloat(plannedReels).toFixed(3))
                    ? Math.round((parseFloat(plannedReels) * 1).toFixed(3))
                    : 1;
                  order["planning_quantity"] = order.no_of_reel_sheet;
                }

                //calculate planned weight
                let planned_weight = calculatePlannedWeight(
                  parseFloat(widthData),
                  productResp[0].bulk,
                  parseFloat(order.outer_dia[0]?.split(" ")[0]) * orderDim_Rewinder_Unit_Conversion[order.outer_dia[0]?.split(" ")[1]],
                  parseFloat(order.inner_dia?.split(" ")[0]) * orderDim_Rewinder_Unit_Conversion[order.inner_dia?.split(" ")[1]],
                  order.quantity
                );
                  let plannedWt =
                    planned_weight *
                    conversionFactorTonneToUnits[order.weight_unit];
                  order.planned_weight = plannedWt
                    ? parseFloat(plannedWt).toFixed(3)
                    : 0;

                  if (
                    productResp[0]?.units.per_weight_unit.toLowerCase() !==
                    order?.per_weight_unit.toLowerCase()
                  ) {
                    order.per_weight_unit = productResp[0]?.units.per_weight_unit;
                  }
                  let netPrice;
                  if (order.quantity_type == "weight") {
                    netPrice =
                      parseFloat(order.dealer_price) *
                      parseFloat(order.weight)?.toFixed(3);
                  }
                  order.net_price = netPrice ? netPrice?.toFixed(3) : 0;
                  order.quantity = Math.round(order.quantity);
                }

            }
          }

          if (order.type == "sheet" && order.quantity_type == "reel_sheet") {
            order["planned_sheets"] = order.no_of_reel_sheet;
          }

          if (order.quantity_type === "weight") {
            let calculated_lower_tolerance = 0;
            let calculated_upper_tolerance = 0;
            if (order.weight) {
              let upperTol =
                (parseFloat(order.weight)?.toFixed(3) *
                  (100 + parseFloat(upperTolerance))) /
                100;
              let lowerTol =
                (parseFloat(order.weight)?.toFixed(3) *
                  (100 - parseFloat(lowerTolerance))) /
                100;
              calculated_lower_tolerance = lowerTol.toFixed(3);
              calculated_upper_tolerance = upperTol.toFixed(3);
            }
            order["tolerances"] = {
              weight: {
                upper_tolerance: parseFloat(upperTolerance),
                lower_tolerance: parseFloat(lowerTolerance),
                calculated_lower_tolerance: parseFloat(
                  calculated_lower_tolerance
                ),
                calculated_upper_tolerance: parseFloat(
                  calculated_upper_tolerance
                ),
                units: order.weight_unit
                  ? order.weight_unit
                  : measurementData.data.units_management.weight.default,
              },
            };
          } else {
            order["tolerances"] = {};
          }

          order["packaging_details"] = order.packaging_details.id;
          order["ply"] = parseFloat(order.ply);
          order.units = {
            weight: order.weight_unit
              ? order.weight_unit
              : measurementData.data.units_management.weight.default,
            ...(order.type === "sheet" && { length: order.size_unit }),
            width: order.size_unit,
            planned_weight:
              order.quantity_type === "reel_sheet"
                ? measurementData.data.units_management.weight.default
                : order.weight_unit,
            // ...order.type === "sheet" && {calculated_upper_tolerance: order.quantity_type === "reel_sheet" ? measurementData.data.units_management.weight.default : order.weight_unit},
            // ...order.type === "sheet" && {calculated_lower_tolerance: order.quantity_type === "reel_sheet" ? measurementData.data.units_management.weight.default : order.weight_unit},
            // core_id: order.type === "sheet" ? measurementData?.data.units_management.length.default : coreIdUnit,
            // reel_od: order.type === "sheet" ? measurementData?.data.units_management.length.default : reelOdUnit,
            dealer_price: order.currency,
            customer_price: order.currency,
            net_price: order.currency,
            per_weight_unit: order?.per_weight_unit,
          };
          dataToSave.pos[0].orders[index].order = order;
          // });
        }
      }
    } catch (error) {
      console.log(error);
      setLoadings(false);
      setResendApprovalLoading(false);
    }
    console.log(dataToSave);
    await saveUploadedOrders(dataToSave, location.state.format)
      .then((response) => {
        if (!response.error) {
          setSavedState(true);
        } else {
          setSavedState(false);
        }
        let orders = ordersForSelectedPo;
        orders.data.pos[location.state.selectedPoIndex]["isPOSaved"] = true;
        setOrdersForSelectedPo(orders);
        setActionToaster({
          error: response.error,
          msg: "Orders are successfully uploaded",
        });
        setLoadings(false);
        showToaster();
        setTimeout(() => {
          history("../order-records/po-validation", {
            state: {
              action: orders,
              format: location.state.format,
              fileName: location.state?.fileName,
            },
          });
        }, 2000);
      })
      .catch((error) => {
        setLoadings(false);
        setResendApprovalLoading(false);
        setActionToaster({
          error: error.response.data.error,
          msg: error.response.data.msg,
        });
        showToaster();
      });
  };

  const handleType = (orderNumber) => {
    let orders = ordersForSelectedPo;
    const index = orders.data.pos[
      location.state.selectedPoIndex
    ].orders.findIndex(function (item, i) {
      return item.order.orderNumber === orderNumber;
    });
    orders.data.pos[location.state.selectedPoIndex].orders[index].order.type =
      form.getFieldValue(`type${orderNumber}`);
    if (
      orders.data.pos[location.state.selectedPoIndex].orders[index].errors.type
    ) {
      delete orders.data.pos[location.state.selectedPoIndex].orders[index]
        .errors["type"];
      orders.data.pos[location.state.selectedPoIndex].orders[
        index
      ].error_count =
        orders.data.pos[location.state.selectedPoIndex].orders[index]
          .error_count - 1;
    }
    setOrdersForSelectedPo(orders);
    setRerendering(true);
  };

  const handleProduct = (orderNumber) => {
    let orders = ordersForSelectedPo;
    const index = orders.data.pos[
      location.state.selectedPoIndex
    ].orders.findIndex(function (item, i) {
      return item.order.orderNumber === orderNumber;
    });
    orders.data.pos[location.state.selectedPoIndex].orders[
      index
    ].order.product = form.getFieldValue(`product${orderNumber}`);
    if (
      orders.data.pos[location.state.selectedPoIndex].orders[index].errors
        .product
    ) {
      delete orders.data.pos[location.state.selectedPoIndex].orders[index]
        .errors["product"];
      orders.data.pos[location.state.selectedPoIndex].orders[
        index
      ].error_count =
        orders.data.pos[location.state.selectedPoIndex].orders[index]
          .error_count - 1;
    }
    if (
      orders.data.pos[location.state.selectedPoIndex].orders[index].errors
        .product_spec
    ) {
      delete orders.data.pos[location.state.selectedPoIndex].orders[index]
        .errors["product_spec"];
      orders.data.pos[location.state.selectedPoIndex].orders[
        index
      ].error_count =
        orders.data.pos[location.state.selectedPoIndex].orders[index]
          .error_count - 1;
    }

    // setRerendering(true);
    getProductDetails(form.getFieldValue(`product${orderNumber}`))
      .then((response) => {
        setProductData({
          bulk: `${response.data.bulk}`,
          gsm: `${response.data.gsm}`,
        });
        // form.setFieldsValue({ [`product_spec${orderNumber}`]: response.data.product_spec });
        orders.data.pos[location.state.selectedPoIndex].orders[
          index
        ].order.product_spec = response.data.product_spec;
        setOrdersForSelectedPo(orders);
        setRerendering(true);
      })
      .catch((error) => {
        console.log("Error in getting product specification list");
      });
  };

  const handlePly = (orderNumber) => {
    let orders = ordersForSelectedPo;
    const index = orders.data.pos[
      location.state.selectedPoIndex
    ].orders.findIndex(function (item, i) {
      return item.order.orderNumber === orderNumber;
    });
    orders.data.pos[location.state.selectedPoIndex].orders[index].order.ply =
      form.getFieldValue(`ply${orderNumber}`);
    if (
      orders.data.pos[location.state.selectedPoIndex].orders[index].errors.ply
    ) {
      delete orders.data.pos[location.state.selectedPoIndex].orders[index]
        .errors["ply"];
      orders.data.pos[location.state.selectedPoIndex].orders[
        index
      ].error_count =
        orders.data.pos[location.state.selectedPoIndex].orders[index]
          .error_count - 1;
    }
    setOrdersForSelectedPo(orders);
    setRerendering(true);
  };

  const onSizeChange = (orderNumber) => {
    let orders = ordersForSelectedPo;
    const index = orders.data.pos[
      location.state.selectedPoIndex
    ].orders.findIndex(function (item, i) {
      return item.order.orderNumber === orderNumber;
    });
    if (
      orders.data.pos[location.state.selectedPoIndex].orders[index].order
        .type == "sheet"
    ) {
      orders.data.pos[location.state.selectedPoIndex].orders[
        index
      ].order.width = form.getFieldValue(`size${orderNumber}`).split("x")[0]
        ? parseFloat(form.getFieldValue(`size${orderNumber}`).split("x")[0])
        : "";
      orders.data.pos[location.state.selectedPoIndex].orders[
        index
      ].order.length = form.getFieldValue(`size${orderNumber}`).split("x")[1]
        ? parseFloat(form.getFieldValue(`size${orderNumber}`).split("x")[1])
        : "";
    } else {
      orders.data.pos[location.state.selectedPoIndex].orders[
        index
      ].order.width = form.getFieldValue(`size${orderNumber}`)
        ? parseFloat(form.getFieldValue(`size${orderNumber}`))
        : "";
    }
    if (
      orders.data.pos[location.state.selectedPoIndex].orders[index].errors
        .width ||
      orders.data.pos[location.state.selectedPoIndex].orders[index].errors
        .length
    ) {
      if (
        orders.data.pos[location.state.selectedPoIndex].orders[index].errors
          .width
      ) {
        delete orders.data.pos[location.state.selectedPoIndex].orders[index]
          .errors["width"];
        orders.data.pos[location.state.selectedPoIndex].orders[
          index
        ].error_count =
          orders.data.pos[location.state.selectedPoIndex].orders[index]
            .error_count - 1;
      } else if (
        orders.data.pos[location.state.selectedPoIndex].orders[index].errors
          .length
      ) {
        delete orders.data.pos[location.state.selectedPoIndex].orders[index]
          .errors["length"];
        orders.data.pos[location.state.selectedPoIndex].orders[
          index
        ].error_count =
          orders.data.pos[location.state.selectedPoIndex].orders[index]
            .error_count - 1;
      }
      let failedOrders = orders.data.pos[
        location.state.selectedPoIndex
      ].orders.filter((item) => (show ? item.error_count > 0 : item));
      setFilteredOrders(failedOrders);
    }
    setOrdersForSelectedPo(orders);
  };

  const onSizeUnitChange = (orderNumber) => {
    let orders = ordersForSelectedPo;
    orders.data.pos[location.state.selectedPoIndex].orders.map(
      (order, index1) => {
        if (orderNumber === order.order.orderNumber) {
          // if (form.getFieldValue(`sizeUnit${orderNumber}`) == 'mm' && order.order.size_unit == 'cm') {
          //   order.order.width = (order.order.width * 10).toFixed(3);
          // }
          // if (form.getFieldValue(`sizeUnit${orderNumber}`) == 'mm' && order.order.size_unit == 'inch') {
          //   order.order.width = (order.order.width * 25.4).toFixed(3);
          // }

          // if (form.getFieldValue(`sizeUnit${orderNumber}`) == 'cm' && order.order.size_unit == 'inch') {
          //   order.order.width = (order.order.width * 2.54).toFixed(3);
          // }

          // if (form.getFieldValue(`sizeUnit${orderNumber}`) == 'cm' && order.order.size_unit == 'mm') {
          //   order.order.width = (order.order.width / 10).toFixed(3);
          // }

          // if (form.getFieldValue(`sizeUnit${orderNumber}`) == 'inch' && order.order.size_unit == 'mm') {
          //   order.order.width = (order.order.width / 25.4).toFixed(3);
          // }

          // if (form.getFieldValue(`sizeUnit${orderNumber}`) == 'inch' && order.order.size_unit == 'cm') {
          //   order.order.width = (order.order.width / 2.54).toFixed(3);
          // }

          // form.setFieldsValue({ [`size${order.order.orderNumber}`]: order.order.width });

          // if(order.order.type == 'sheet')
          // {
          //   if (form.getFieldValue(`sizeUnit${orderNumber}`) == 'mm' && order.order.size_unit == 'cm') {
          //     order.order.length = (order.order.length * 10).toFixed(3);
          //   }
          //   if (form.getFieldValue(`sizeUnit${orderNumber}`) == 'mm' && order.order.size_unit == 'inch') {
          //     order.order.length = (order.order.length * 25.4).toFixed(3);
          //   }

          //   if (form.getFieldValue(`sizeUnit${orderNumber}`) == 'cm' && order.order.size_unit == 'inch') {
          //     order.order.length = (order.order.length * 2.54).toFixed(3);
          //   }

          //   if (form.getFieldValue(`sizeUnit${orderNumber}`) == 'cm' && order.order.size_unit == 'mm') {
          //     order.order.length = (order.order.length / 10).toFixed(3);
          //   }

          //   if (form.getFieldValue(`sizeUnit${orderNumber}`) == 'inch' && order.order.size_unit == 'mm') {
          //     order.order.length = (order.order.length / 25.4).toFixed(3);
          //   }

          //   if (form.getFieldValue(`sizeUnit${orderNumber}`) == 'inch' && order.order.size_unit == 'cm') {
          //     order.order.length = (order.order.length / 2.54).toFixed(3);
          //   }
          //   form.setFieldsValue({ [`size${order.order.orderNumber}`]: order.order.length });

          // }
          order.order.size_unit = form.getFieldValue(`sizeUnit${orderNumber}`);
          form.setFieldsValue({
            [`sizeUnit${order.order.orderNumber}`]: form.getFieldValue(
              `sizeUnit${orderNumber}`
            ),
          });
          if (order.errors.size_unit) {
            delete order.errors["size_unit"];
            order.error_count = order.error_count - 1;
          }
        }
      }
    );
    let failedOrders = orders.data.pos[
      location.state.selectedPoIndex
    ].orders.filter((item) => (show ? item.error_count > 0 : item));
    setFilteredOrders(failedOrders);
    setOrdersForSelectedPo(orders);
    // form.resetFields();
    setRerendering(true);
  };

  const onOrderWeightChange = (orderNumber) => {
    let orders = ordersForSelectedPo;
    const index = orders.data.pos[
      location.state.selectedPoIndex
    ].orders.findIndex(function (item, i) {
      return item.order.orderNumber === orderNumber;
    });
    orders.data.pos[location.state.selectedPoIndex].orders[index].order.weight =
      form.getFieldValue(`orderWeight${orderNumber}`)
        ? parseFloat(form.getFieldValue(`orderWeight${orderNumber}`))
        : "";
    if (
      orders.data.pos[location.state.selectedPoIndex].orders[index].errors
        .weight
    ) {
      delete orders.data.pos[location.state.selectedPoIndex].orders[index]
        .errors["weight"];
      orders.data.pos[location.state.selectedPoIndex].orders[
        index
      ].error_count =
        orders.data.pos[location.state.selectedPoIndex].orders[index]
          .error_count - 1;
      let failedOrders = orders.data.pos[
        location.state.selectedPoIndex
      ].orders.filter((item) => (show ? item.error_count > 0 : item));
      setFilteredOrders(failedOrders);
    }
    setOrdersForSelectedPo(orders);
  };

  const onOrderWeightUnitChange = (orderNumber) => {
    let orders = ordersForSelectedPo;
    orders.data.pos[location.state.selectedPoIndex].orders.map(
      (order, index1) => {
        if (orderNumber === order.order.orderNumber) {
          // if (order.order.weight_unit == 'tonne' && form.getFieldValue(`orderWeightUnit${orderNumber}`) == 'kg') {
          //   order.order.weight = order.order.weight * 1000;
          // }
          // else {
          //   order.order.weight = order.order.weight / 1000;
          // }
          // form.setFieldsValue({ [`orderWeight${order.order.orderNumber}`]: order.order.weight });
          order.order.weight_unit = form.getFieldValue(
            `orderWeightUnit${orderNumber}`
          );
          form.setFieldsValue({
            [`orderWeightUnit${order.order.orderNumber}`]: form.getFieldValue(
              `orderWeightUnit${orderNumber}`
            ),
          });

          if (order.errors.weight_unit) {
            delete order.errors["weight_unit"];
            order.error_count = order.error_count - 1;
          }
        }
      }
    );
    let failedOrders = orders.data.pos[
      location.state.selectedPoIndex
    ].orders.filter((item) => (show ? item.error_count > 0 : item));
    setFilteredOrders(failedOrders);
    setOrdersForSelectedPo(orders);
    setRerendering(true);
  };

  const onCurrencyChange = (orderNumber) => {
    let orders = ordersForSelectedPo;
    orders.data.pos[location.state.selectedPoIndex].orders.map(
      (order, index1) => {
        if (orderNumber === order.order.orderNumber) {
          order.order.currency = form.getFieldValue(`currency${orderNumber}`);
          form.setFieldsValue({
            [`currency${order.order.orderNumber}`]: form.getFieldValue(
              `currency${orderNumber}`
            ),
          });
          if (order.errors.currency) {
            delete order.errors["currency"];
            order.error_count = order.error_count - 1;
          }
        }
      }
    );
    let failedOrders = orders.data.pos[
      location.state.selectedPoIndex
    ].orders.filter((item) => (show ? item.error_count > 0 : item));
    setFilteredOrders(failedOrders);
    setOrdersForSelectedPo(orders);
    setRerendering(true);
  };

  const onWeightUnitChange = (orderNumber) => {
    let orders = ordersForSelectedPo;
    orders.data.pos[location.state.selectedPoIndex].orders.map(
      (order, index1) => {
        if (orderNumber === order.order.orderNumber) {
          order.order.per_weight_unit = form.getFieldValue(
            `per_weight_unit${orderNumber}`
          );
          form.setFieldsValue({
            [`per_weight_unit${order.order.orderNumber}`]: form.getFieldValue(
              `per_weight_unit${orderNumber}`
            ),
          });
          if (order.errors.per_weight_unit) {
            delete order.errors["per_weight_unit"];
            order.error_count = order.error_count - 1;
          }
        }
      }
    );
    let failedOrders = orders.data.pos[
      location.state.selectedPoIndex
    ].orders.filter((item) => (show ? item.error_count > 0 : item));
    setFilteredOrders(failedOrders);
    setOrdersForSelectedPo(orders);
    setRerendering(true);
  };

  const onPackagingChange = (orderNumber, e) => {
    let orders = ordersForSelectedPo;
    orders.data.pos[location.state.selectedPoIndex].orders.map(
      (order, index1) => {
        let packagingValue;
        if (orderNumber === order.order.orderNumber) {
          order.order.packaging_details = {};
          if (order?.order?.type?.toLowerCase() == "sheet") {
            packagingValue = sheetPackagingData?.filter(
              (ele) =>
                ele.id == form.getFieldValue(`packagingType${orderNumber}`)
            );
          } else {
            packagingValue = reelPackagingData?.filter(
              (ele) =>
                ele.id == form.getFieldValue(`packagingType${orderNumber}`)
            );
          }
          order.order.packaging_details = packagingValue[0];
          form.setFieldsValue({
            [`packagingType${order.order.orderNumber}`]: form
              .getFieldValue(`packagingType${orderNumber}`)
              .toString(),
          });

          if (order.errors.packaging_details) {
            delete order.errors["packaging_details"];
            order.error_count = order.error_count - 1;
          }
        }
      }
    );
    let failedOrders = orders.data.pos[
      location.state.selectedPoIndex
    ].orders.filter((item) => (show ? item.error_count > 0 : item));
    setFilteredOrders(failedOrders);
    setOrdersForSelectedPo(orders);
    setRerendering(true);
  };

  const onQuantityChange = (orderNumber) => {
    let orders = ordersForSelectedPo;
    const index = orders.data.pos[
      location.state.selectedPoIndex
    ].orders.findIndex(function (item, i) {
      return item.order.orderNumber === orderNumber;
    });
    orders.data.pos[location.state.selectedPoIndex].orders[
      index
    ].order.no_of_reel_sheet = form.getFieldValue(`quantity${orderNumber}`)
      ? parseFloat(form.getFieldValue(`quantity${orderNumber}`))
      : "";
    if (
      orders.data.pos[location.state.selectedPoIndex].orders[index].errors
        .no_of_reel_sheet
    ) {
      delete orders.data.pos[location.state.selectedPoIndex].orders[index]
        .errors["no_of_reel_sheet"];
      orders.data.pos[location.state.selectedPoIndex].orders[
        index
      ].error_count =
        orders.data.pos[location.state.selectedPoIndex].orders[index]
          .error_count - 1;
      let failedOrders = orders.data.pos[
        location.state.selectedPoIndex
      ].orders.filter((item) => (show ? item.error_count > 0 : item));
      setFilteredOrders(failedOrders);
    }
    setOrdersForSelectedPo(orders);
  };

  const onPriceChange = (orderNumber) => {
    let orders = ordersForSelectedPo;
    const index = orders.data.pos[
      location.state.selectedPoIndex
    ].orders.findIndex(function (item, i) {
      return item.order.orderNumber === orderNumber;
    });
    orders.data.pos[location.state.selectedPoIndex].orders[
      index
    ].order.dealer_price = form.getFieldValue(`price${orderNumber}`)
      ? parseFloat(form.getFieldValue(`price${orderNumber}`))
      : "";
    if (
      orders.data.pos[location.state.selectedPoIndex].orders[index].errors
        .dealer_price
    ) {
      delete orders.data.pos[location.state.selectedPoIndex].orders[index]
        .errors["dealer_price"];
      orders.data.pos[location.state.selectedPoIndex].orders[
        index
      ].error_count =
        orders.data.pos[location.state.selectedPoIndex].orders[index]
          .error_count - 1;
      let failedOrders = orders.data.pos[
        location.state.selectedPoIndex
      ].orders.filter((item) => (show ? item.error_count > 0 : item));
      setFilteredOrders(failedOrders);
    }
    setOrdersForSelectedPo(orders);
  };

  const onCustPriceChange = (orderNumber) => {
    let orders = ordersForSelectedPo;
    const index = orders.data.pos[
      location.state.selectedPoIndex
    ].orders.findIndex(function (item, i) {
      return item.order.orderNumber === orderNumber;
    });
    orders.data.pos[location.state.selectedPoIndex].orders[
      index
    ].order.customer_price = form.getFieldValue(`customerPrice${orderNumber}`)
      ? parseFloat(form.getFieldValue(`customerPrice${orderNumber}`))
      : "";
    if (
      orders.data.pos[location.state.selectedPoIndex].orders[index].errors
        .dealer_price
    ) {
      delete orders.data.pos[location.state.selectedPoIndex].orders[index]
        .errors["customer_price"];
      orders.data.pos[location.state.selectedPoIndex].orders[
        index
      ].error_count =
        orders.data.pos[location.state.selectedPoIndex].orders[index]
          .error_count - 1;
      let failedOrders = orders.data.pos[
        location.state.selectedPoIndex
      ].orders.filter((item) => (show ? item.error_count > 0 : item));
      setFilteredOrders(failedOrders);
    }
    setOrdersForSelectedPo(orders);
  };

  const onDeliveryDateChange = (orderNumber, newDate) => {
    if (!newDate || !moment(newDate).isValid()) return;
  
    const orders = { ...ordersForSelectedPo }; 
    const poIndex = location.state.selectedPoIndex;
    const dateStr = moment(newDate).format("YYYY-MM-DD 00:00:00");
  
    const index = orders.data.pos[poIndex].orders.findIndex(
      (item) => item.order.orderNumber === orderNumber
    );
    const targetOrder = orders.data.pos[poIndex].orders[index];
    targetOrder.order.delivery_date = dateStr;
  
    form.setFieldsValue({
      [`deliveryDate${orderNumber}`]: moment(dateStr),
    });
  
    if (targetOrder.errors.delivery_date) {
      delete targetOrder.errors["delivery_date"];
      targetOrder.error_count -= 1;
    }
  
    if (orders.data.pos[poIndex].errors.delivery_date) {
      delete orders.data.pos[poIndex].errors["delivery_date"];
      orders.data.pos[poIndex].error_count -= 1;
    }
  
    setOrdersForSelectedPo(orders);
    setRerendering(true);
  };

  const onGrainChanges = (orderNumber) => {
    let orders = ordersForSelectedPo;
    const index = orders.data.pos[
      location.state.selectedPoIndex
    ].orders.findIndex(function (item, i) {
      return item.order.orderNumber === orderNumber;
    });
    orders.data.pos[location.state.selectedPoIndex].orders[index].order.grain =
      form.getFieldValue(`grain${orderNumber}`);
    if (
      orders.data.pos[location.state.selectedPoIndex].orders[index].errors.grain
    ) {
      delete orders.data.pos[location.state.selectedPoIndex].orders[index]
        .errors["grain"];
      orders.data.pos[location.state.selectedPoIndex].orders[
        index
      ].error_count =
        orders.data.pos[location.state.selectedPoIndex].orders[index]
          .error_count - 1;
    }
    setOrdersForSelectedPo(orders);
    setRerendering(true);
  };

  const onRemarkChange = (orderNumber) => {
    let orders = ordersForSelectedPo;
    const index = orders.data.pos[
      location.state.selectedPoIndex
    ].orders.findIndex(function (item, i) {
      return item.order.orderNumber === orderNumber;
    });
    orders.data.pos[location.state.selectedPoIndex].orders[
      index
    ].order.remarks = (form.getFieldValue(`remark${orderNumber}`));
    if (
      orders.data.pos[location.state.selectedPoIndex].orders[index].errors
        .remarks
    ) {
      delete orders.data.pos[location.state.selectedPoIndex].orders[index]
        .errors["remarks"];
      orders.data.pos[location.state.selectedPoIndex].orders[
        index
      ].error_count =
        orders.data.pos[location.state.selectedPoIndex].orders[index]
          .error_count - 1;
      let failedOrders = orders.data.pos[
        location.state.selectedPoIndex
      ].orders.filter((item) => (show ? item.error_count > 0 : item));
      setFilteredOrders(failedOrders);
    }
    setOrdersForSelectedPo(orders);
  };

  const onReelODChange = (orderNumber,value) => {
    // const coreODFieldValue = form.getFieldValue(`core_OD${orderNumber}`);
    // const coreODParts = coreODFieldValue ? String(coreODFieldValue).trim().split(/\s+/) : [];
    // let coreodConversion = orderDim_Rewinder_Unit_Conversion[coreODParts[1]] ?? orderDim_Rewinder_Unit_Conversion[value?.split(" ")[1]];
    // let reelodConversion = orderDim_Rewinder_Unit_Conversion[value?.split(" ")[1]];
    // let coreODValue = (parseFloat(coreODParts[0]) || 0) * (coreodConversion ?? 0);
    // let reelOdValue = (parseFloat(value?.split(" ")[0]) || 0) * (reelodConversion ?? 0);
    // if (coreODValue > reelOdValue) {
    //   setReelError(true);
    //   return;
    // }
    // setReelError(false);
    let orders = ordersForSelectedPo;
    let reelODValue = value?.split(" ")[0];
    let reelODUnit = value?.split(" ")[1];
    const index = orders.data.pos[
      location.state.selectedPoIndex
    ].orders.findIndex(function (item, i) {
      return item.order.orderNumber === orderNumber;
    });
    orders.data.pos[location.state.selectedPoIndex].orders[index].order.reel_od = parseFloat(reelODValue);
    orders.data.pos[location.state.selectedPoIndex].orders[index].order.reel_od_unit = reelODUnit;
    orders.data.pos[location.state.selectedPoIndex].orders[index].order.units.reel_od_unit = reelODUnit;
    if (
      orders.data.pos[location.state.selectedPoIndex].orders[index].errors
        .reel_od
    ) {
      delete orders.data.pos[location.state.selectedPoIndex].orders[index]
        .errors["reel_od"];
      orders.data.pos[location.state.selectedPoIndex].orders[
        index
      ].error_count =
        orders.data.pos[location.state.selectedPoIndex].orders[index]
          .error_count - 1;
      let failedOrders = orders.data.pos[
        location.state.selectedPoIndex
      ].orders.filter((item) => (show ? item.error_count > 0 : item));
      setFilteredOrders(failedOrders);
    }
    console.log('orders',orders);
    
    setOrdersForSelectedPo(orders);
  }

  const onCoreODChange = (orderNumber,value) => {
    // const reelODFieldValue = form.getFieldValue(`reel_OD${orderNumber}`);
    // const reelODParts = reelODFieldValue ? String(reelODFieldValue).trim().split(/\s+/) : [];
    // let coreodConversion = orderDim_Rewinder_Unit_Conversion[value?.split(" ")[1]];
    // let reelodConversion = orderDim_Rewinder_Unit_Conversion[reelODParts[1]] ?? orderDim_Rewinder_Unit_Conversion[value?.split(" ")[1]];
    // let coreODValue = (parseFloat(value?.split(" ")[0]) || 0) * (coreodConversion ?? 0);
    // let reelOdValue = (parseFloat(reelODParts[0]) || 0) * (reelodConversion ?? 0);
    // if (coreODValue > reelOdValue) {
    //   setCoreError(true);
    //   return;
    // }
    // setCoreError(false);
    let orders = ordersForSelectedPo;
    let coreIdValue = value?.split(" ")[0];
    let coreIdUnit = value?.split(" ")[1];
    const index = orders.data.pos[
      location.state.selectedPoIndex
    ].orders.findIndex(function (item, i) {
      return item.order.orderNumber === orderNumber;
    });
    orders.data.pos[location.state.selectedPoIndex].orders[index].order.core_id = parseFloat(coreIdValue);
    orders.data.pos[location.state.selectedPoIndex].orders[index].order.core_id_unit = coreIdUnit;
    orders.data.pos[location.state.selectedPoIndex].orders[index].order.units.core_id_unit = coreIdUnit;
    if (
      orders.data.pos[location.state.selectedPoIndex].orders[index].errors
        .core_id
    ) {
      delete orders.data.pos[location.state.selectedPoIndex].orders[index]
        .errors["core_id"];
      orders.data.pos[location.state.selectedPoIndex].orders[
        index
      ].error_count =
        orders.data.pos[location.state.selectedPoIndex].orders[index]
          .error_count - 1;
      let failedOrders = orders.data.pos[
        location.state.selectedPoIndex
      ].orders.filter((item) => (show ? item.error_count > 0 : item));
      setFilteredOrders(failedOrders);
    }
    setOrdersForSelectedPo(orders);
  }
  const saveDetails = (state) => {
    // let orders = ordersForSelectedPo;
    let orders = {
      data: {
        pos: [ordersForSelectedPo.data.pos[location.state.selectedPoIndex]],
      },
    };
    orders.data["state"] = state;
    setPoDataToSave(orders);
    setIsVisible(false);
    // setOrdersForSelectedPo(orders);
    // setRerendering(true);
    if (state == "open") {
      setLoadings(true);
      setOtherButtonLoadingLoadings(true);
    } else {
      setResendApprovalLoading(true);
      setResendAppOtherButtonLoading(true);
    }
    form.submit();
  };

  const goBack = () => {
    setGobackLoading(true);
    let originalArr = location.state.originalArr;
    // let selectedPOInd = originalArr.data.pos.findIndex(
    //   (ele) =>
    //     ele.po.number ==
    //     ordersForSelectedPo.data.pos[location.state.selectedPoIndex].po.number
    // );
    originalArr.data.pos[location.state.selectedPoIndex]["orders"] =
      ordersForSelectedPo.data.pos[location.state.selectedPoIndex].orders;

    setTimeout(() => {
      history("../order-records/po-validation", {
        state: {
          // action: ordersForSelectedPo,
          action: originalArr,
          // filterState: location.state.filterState,
          format: location.state.format,
          currentPage: location.state.currentPage,
        },
      });
    }, 400);
  };

  const showToaster = () => {
    setVisibleToaster(true);
    setTimeout(() => setVisibleToaster(false), 2000);
  };

  // const onProductChange = (index) => {
  //   let orders = ordersForSelectedPo;
  //   orders.data.pos[location.state.selectedPoIndex].orders[index].order.product = form.getFieldValue(`product${index}`);
  //   if (orders.data.pos[location.state.selectedPoIndex].orders[index].errors.product) {
  //     delete orders.data.pos[location.state.selectedPoIndex].orders[index].errors['product'];
  //     orders.data.pos[location.state.selectedPoIndex].orders[index].error_count = orders.data.pos[location.state.selectedPoIndex].orders[index].error_count - 1;
  //     setOrdersForSelectedPo(orders);
  //     setRerendering(true);
  //   }
  // }

  useEffect(() => {
    (async () => {
      document.body.style.overflow = "hidden";
      ordersForSelectedPo.data.pos[0].orders.map((item) => {
        if (item.order.type === "sheet") {
          setIsVisible(true);
        }
      });

      try {
        const response = await getReelCoreValues();
        if (!response.error) {
          // setReelCoreData(response);
          const reelData = response.reel_data.map((item) => {
            return {
              value: item[0] + " " + item[1],
            };
          });
          const coreData = response.core_data.map((item) => {
            return {
              value: item[0] + " " + item[1],
            };
          });
          setCoreValues(coreData);
          setReelvalues(reelData);
        }
      } catch (error) {
        console.log(error);
      }

      getProductsData({ status: "active" })
        .then((response) => {
          setProducts(response);
        })
        .catch((error) => {
          console.log("Error in fetching products list:", error);
        });

      getMachineGradeSelect()
        .then((response) => {
          const reelValue = response.data.data.settings.order_types[0].value;
          const sheetValue = response.data.data.settings.order_types[1].value;
          setUpperTol(
            response?.data?.data?.settings?.order_types[2]?.data
              ?.order_tolerance?.upper_tolerance
          );
          setLowerTol(
            response?.data?.data?.settings?.order_types[2]?.data
              ?.order_tolerance?.lower_tolerance
          );
          setDefaultMixedGrain(
            response.data.data.settings.order_types[1].mixed_grain
          );
          const typeData =
            reelValue && sheetValue
              ? [
                  { label: "Reel", value: "reel" },
                  { label: "Sheet", value: "sheet" },
                ]
              : reelValue
              ? [{ label: "Reel", value: "reel" }]
              : sheetValue
              ? [{ label: "Sheet", value: "sheet" }]
              : [];
          setOrderTypes(typeData);
        })
        .catch((error) => console.log(error));

      try {
        const unitData = await getUnitData();
        if (!unitData.error) {
          setMeasurementData(unitData);
          setDimesionUnitList(unitData.data.units_management.length.data);
          setWeightUnitList(unitData.data.units_management.weight.data);
          let currencyData = currency_List?.filter((item) =>
            unitData.data.units_management.currency.data.includes(item.code)
          );
          setCurrencyUnitData(currencyData);
        }
      } catch (err) {
        console.log(err);
      }

      try {
        const resp = await getPackagingList("", "active");
        if (!resp.error) {
          setReelPackagingData(resp.data.filter((item) => item.type == "reel"));
          setSheetPackagingData(
            resp.data.filter((item) => item.type == "sheet")
          );
          setRerendering(true);
        }
      } catch (err) {
        console.log(err);
      }

      let orderstoshow = [];
      filteredOrders?.map((item, index) => {
        if (index < 25) {
          orderstoshow.push(item);
        }
      });
      setOrdersToShow(filteredOrders);
    })();
    return () => {
      setOrderTypes([]);
      document.body.style.overflow = "auto";
    };
  }, []);

  const setRowCount = () => {
    rowCount.current = true;
  };

  const filterRecords = (filterParam) => {
    let orders = ordersForSelectedPo;
    let failedOrders = orders.data.pos[
      location.state.selectedPoIndex
    ].orders.filter((item) => (filterParam ? item.error_count > 0 : item));
    setFilteredOrders(failedOrders);
    setOrdersToShow(failedOrders);
    // setOrdersForSelectedPo(orders);
    setRerendering(true);
  };

  useEffect(() => {
    if (rerendering) {
      form.resetFields();
      setRerendering(false);
    }
  }, [rerendering]);

  const handleScroll = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };

  const onGrainChangesChange = (e, orderNumber) => {
    let orders = ordersForSelectedPo;
    const index = orders.data.pos[
      location.state.selectedPoIndex
    ].orders.findIndex(function (item, i) {
      return item.order.orderNumber === orderNumber;
    });
    orders.data.pos[location.state.selectedPoIndex].orders[
      index
    ].order.rotaion = e.target.checked;
    if (
      orders.data.pos[location.state.selectedPoIndex].orders[index].errors
        .rotaion
    ) {
      delete orders.data.pos[location.state.selectedPoIndex].orders[index]
        .errors["rotaion"];
      orders.data.pos[location.state.selectedPoIndex].orders[
        index
      ].error_count =
        orders.data.pos[location.state.selectedPoIndex].orders[index]
          .error_count - 1;
    }
    setOrdersForSelectedPo(orders);
    setRerendering(true);
  };

  const onGrainMixingChange = (e, orderNumber) => {
    let orders = ordersForSelectedPo;
    const index = orders.data.pos[
      location.state.selectedPoIndex
    ].orders.findIndex(function (item, i) {
      return item.order.orderNumber === orderNumber;
    });
    orders.data.pos[location.state.selectedPoIndex].orders[
      index
    ].order.grain_mixing = e.target.checked;
    if (
      orders.data.pos[location.state.selectedPoIndex].orders[index].errors
        .grain_mixing
    ) {
      delete orders.data.pos[location.state.selectedPoIndex].orders[index]
        .errors["grain_mixing"];
      orders.data.pos[location.state.selectedPoIndex].orders[
        index
      ].error_count =
        orders.data.pos[location.state.selectedPoIndex].orders[index]
          .error_count - 1;
    }
    setOrdersForSelectedPo(orders);
    setRerendering(true);
  };

  const onPageChange = (page, pageSize) => {
    let start = page * pageSize - pageSize;
    let end = page * pageSize;
    if (end > filteredOrders.length) {
      end = filteredOrders.length;
    }
    setOrdersToShow(filteredOrders.slice(start, end));
  };

  const RowData = ({ index, style }) =>
    index !== undefined && (
      <div style={style}>
        <Row
          gutter={[10, 10]}
          className="groupForm"
          style={{ width: "340%", marginBottom: "10px", paddingBottom: "10px" }}
        >
          {/* <Col style={{ paddingTop: index == 0 ? "40px" : "10px" }}>
                          {(ordersToShow[index].error_count || ordersToShow[index].errors.hasOwnProperty(ordersToShow[index])) ? (
                            <Iconmoon icon="wrong" size={14} color="#EA655B" />
                          ) : (
                            <div style={{ width: "14px" }}></div>
                          )
                          }
                        </Col> */}
          <Col style={{ paddingTop: index == 0 ? "40px" : "10px" }}>
            <Styled>
              {/* {(ordersToShow[index].error_count || ordersToShow[index].errors.hasOwnProperty(ordersToShow[index])) && */}
              <Tooltip
                placement="bottomRight"
                title={
                  ordersToShow[index].error_count ||
                  Object.keys(ordersToShow[index]?.errors || {}).length > 0
                    ? "This order has failed validation"
                    : ""
                }
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <div style={{ cursor: "default" }}>
                  {(ordersToShow[index].error_count ||
                  Object.keys(ordersToShow[index]?.errors || {}).length > 0) ? (
                    <Iconmoon icon="wrong" size={14} color="#EA655B" />
                  ) : (
                    <div style={{ width: "14px" }}></div>
                  )}
                </div>
              </Tooltip>
              {/* } */}
            </Styled>
          </Col>
          <Col style={{ width: "70px" }}>
            <div className="boxFormType">
              <Form.Item
                label={index == 0 || !rowCount.current ? "S.No." : ""}
                name={`sno${ordersToShow[index].order.orderNumber}`}
                rules={[]}
                className="dBlock"
                initialValue={ordersToShow[index].order.orderNumber}
              >
                <Input
                  disabled={true}
                  style={{ textTransform: "capitalize" }}
                />
              </Form.Item>
            </div>
          </Col>
          <Col style={{ width: "85px" }}>
            <div className="boxFormType">
              <Form.Item
                label={index == 0 ? "Type" : ""}
                name={`type${ordersToShow[index].order.orderNumber}`}
                rules={[
                  {
                    required: true,
                    message: "This field is required",
                  },
                ]}
                className="dBlock"
                initialValue={ordersToShow[index].order.type}
              >
                <Select
                  placeholder="Type"
                  suffixIcon={<DownArrowDraw />}
                  onChange={() =>
                    handleType(ordersToShow[index].order.orderNumber)
                  }
                  disabled={
                    ordersForSelectedPo.data.pos[location.state.selectedPoIndex]
                      .isPOSaved || location.state.format === "format_4"
                      ? true
                      : false
                  }
                >
                  {orderTypes.map((orderType) => (
                    <Option key={orderType.value}>{orderType.label}</Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
            {ordersToShow[index].errors.hasOwnProperty("type") ? (
              <span className="errorText" style={{ color: "#ea4e2c" }}>
                {ordersToShow[index].errors.type}
              </span>
            ) : null}
          </Col>
          <Col style={{ width: "250px" }}>
            <div className="boxFormType">
              <Form.Item
                label={index == 0 ? "Product" : ""}
                name={`product${ordersToShow[index].order.orderNumber}`}
                rules={[
                  {
                    required: true,
                    message: "This field is required",
                  },
                ]}
                className="dBlock"
                initialValue={ordersToShow[index].order.product}
                // validateStatus={ordersToShow[index].errors.hasOwnProperty('product') ? "error" : null}
                // help={ordersToShow[index].errshowSearchsaors.hasOwnProperty('product') ? ordersToShow[index].errors.product : null}
              >
                <Select
                  placeholder="Select Product"
                  suffixIcon={<DownArrowDraw />}
                  // onBlur={OnProductToggleSelect}
                  // onFocus={OnProductToggleSelect}
                  showSearch
                  optionFilterProp="children"
                  onChange={() =>
                    handleProduct(ordersToShow[index].order.orderNumber)
                  }
                  className="dBlock"
                  style={{ textTransform: "capitalize" }}
                  disabled={
                    ordersForSelectedPo.data.pos[location.state.selectedPoIndex]
                      .isPOSaved
                      ? true
                      : false
                  }
                >
                  {products.map((product) => (
                    <Option key={product.code}>
                      {product.code} - {product.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <p style={{ marginTop: "5px", marginLeft: "5px" }}>
                {ordersToShow[index].order.product_spec}
              </p>
            </div>
            {ordersToShow[index].errors.hasOwnProperty("product") ? (
              <span
                className="errorText"
                style={{ color: "#ea4e2c" }}
                dangerouslySetInnerHTML={{
                  __html: ordersToShow[index].errors.product,
                }}
              ></span>
            ) : null}
          </Col>
          <Col style={{ width: "200px" }}>
            <div className="boxFormType">
              <Form.Item
                label={index == 0 ? "PLY" : ""}
                name={`ply${ordersToShow[index].order.orderNumber}`}
                rules={[
                  {
                    required:
                      ordersToShow[index].order.type === "sheet" ? false : true,
                    message: "This field is required",
                  },
                ]}
                className="dBlock"
                initialValue={ordersToShow[index].order.ply}
              >
                <Select
                  placeholder="Select Ply"
                  suffixIcon={<DownArrowDraw />}
                  showSearch
                  optionFilterProp="children"
                  onChange={() =>
                    handlePly(ordersToShow[index].order.orderNumber)
                  }
                  className="dBlock"
                  style={{ textTransform: "capitalize" }}
                  disabled={
                    ordersForSelectedPo.data.pos[location.state.selectedPoIndex]
                      .isPOSaved || ordersToShow[index].order.type === "sheet"
                      ? true
                      : false
                  }
                >
                  {plyData.map((item) => (
                    <Option key={item.value} value={item.value}>
                      {item.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
            {ordersToShow[index].errors.hasOwnProperty("ply") ? (
              <span
                className="errorText"
                style={{ color: "#ea4e2c" }}
                dangerouslySetInnerHTML={{
                  __html: ordersToShow[index].errors.ply,
                }}
              ></span>
            ) : null}
          </Col>
          {/* <Col style={{ width: "250px" }}>
                          <div className="boxFormType">
                            <Form.Item
                              label={index == 0 ? "Grade/GSM/BF/Quality/Moisture" : ""}
                              name={`product_spec${ordersToShow[index].order.orderNumber}`}
                              rules={[
                                {
                                  required: true,
                                  message: "This field is required",
                                }
                              ]}
                              className="dBlock"
                              initialValue={ordersToShow[index].order.product_spec}
                            >
                              <Input
                                disabled
                                placeholder="Grade/GSM/BF/Quality/Moisture"
                                style={{ textTransform: "capitalize" }}
                              />
                            </Form.Item>
                          </div>
                          {ordersToShow[index].errors.hasOwnProperty('product_spec') ? (
                            <span
                              className="errorText"
                              style={{ color: "#ea4e2c" }}
                            >
                              {ordersToShow[index].errors.product_spec}
                            </span>
                          ) : null}
                        </Col> */}
          <Col style={{ width: "150px" }}>
            <div className="boxFormType">
              <Form.Item
                label={index == 0 ? "Size(WxL)" : ""}
                name={`size${ordersToShow[index].order.orderNumber}`}
                rules={[
                  {
                    required: true,
                    message: "This field is required",
                  },
                  {
                    validator(_, value) {
                      if (
                        ordersToShow[index].order.type === "sheet" &&
                        /^(?:[1-9]\d*(?:\.\d+)?|0\.\d*[1-9])x(?:[1-9]\d*(?:\.\d+)?|0\.\d*[1-9])$/.test(
                          value
                        )
                      ) {
                        return Promise.resolve();
                      } else if (
                        ordersToShow[index].order.type === "reel" &&
                        /^(?!0+(\.0+)?$)\d+(\.\d+)?$/.test(
                          value
                        )
                      ) {
                        return Promise.resolve();
                      } else {
                        return Promise.reject("Valid size is required");
                      }
                    },
                  },
                ]}
                className="dBlock"
                initialValue={
                  ordersToShow[index].order.type === "reel"
                    ? ordersToShow[index].order.width
                    : ordersToShow[index].order.width +
                      "x" +
                      ordersToShow[index].order.length
                }
              >
                <Input
                  placeholder="Enter size"
                  onChange={() =>
                    onSizeChange(ordersToShow[index].order.orderNumber)
                  }
                  style={{ textTransform: "capitalize" }}
                  disabled={
                    ordersForSelectedPo.data.pos[location.state.selectedPoIndex]
                      .isPOSaved
                      ? true
                      : false
                  }
                />
              </Form.Item>
            </div>
            {ordersToShow[index].errors.hasOwnProperty("width") ? (
              <span className="errorText" style={{ color: "#ea4e2c" }}>
                {ordersToShow[index].errors.width}
              </span>
            ) : ordersToShow[index].errors.hasOwnProperty("length") ? (
              <span className="errorText" style={{ color: "#ea4e2c" }}>
                {ordersToShow[index].errors.length}
              </span>
            ) : null}
          </Col>
          <Col style={{ width: "90px" }}>
            <div className="boxFormType">
              <Form.Item
                label={index == 0 ? "Unit" : ""}
                name={`sizeUnit${ordersToShow[index].order.orderNumber}`}
                rules={[
                  {
                    required: true,
                    message: "This field is required",
                  },
                ]}
                className="dBlock"
                initialValue={ordersToShow[index].order.size_unit}
              >
                <Select
                  placeholder="Unit"
                  suffixIcon={<DownArrowDraw />}
                  className="dBlock"
                  // style={{ textTransform: "capitalize" }}
                  onChange={(e) =>
                    onSizeUnitChange(ordersToShow[index].order.orderNumber, e)
                  }
                  disabled={
                    ordersForSelectedPo.data.pos[location.state.selectedPoIndex]
                      .isPOSaved
                      ? true
                      : false
                  }
                >
                  {dimesionUnitList?.map((unit) => (
                    <Option
                      key={`${unit}${ordersToShow[index].order.orderNumber}`}
                      value={unit}
                    >
                      {lengthUnit[unit]?.displayName}
                    </Option>
                  ))}{" "}
                  */
                </Select>
              </Form.Item>
            </div>
            {ordersToShow[index].errors.hasOwnProperty("size_unit") ? (
              <span className="errorText" style={{ color: "#ea4e2c" }}>
                {ordersToShow[index].errors.size_unit}
              </span>
            ) : null}
          </Col>
          {isVisible && (
            <Col style={{ width: "90px" }}>
              {index == 0 && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    padding: "2px 0px 6px 5px",
                  }}
                >
                  {ordersToShow[index].order.type === "sheet" && (
                    <div className="mandatorySymbolColumnHeader">*</div>
                  )}
                  <div>
                    <span className="columnHeader">Grain</span>
                    <Styled style={{ display: "inline-flex" }}>
                      <Tooltip
                        placement="bottomRight"
                        title={"Mandatory for sheet orders."}
                        className="edit-tooltip"
                        getPopupContainer={(triggerNode) => triggerNode}
                      >
                        <span className="infoIcon"></span>
                      </Tooltip>
                    </Styled>
                  </div>
                </div>
              )}
              <div className="boxFormType">
                <Form.Item
                  name={`grain${ordersToShow[index].order.orderNumber}`}
                  rules={
                    ordersToShow[index].order.type === "sheet" && [
                      {
                        required: true,
                        message: "This field is required",
                      },
                    ]
                  }
                  className="dBlock"
                  initialValue={
                    ordersToShow[index].order.type === "sheet"
                      ? ordersToShow[index].order.grain
                      : ""
                  }
                >
                  <Select
                    placeholder="Select Grain"
                    suffixIcon={<DownArrowDraw />}
                    className="dBlock"
                    // style={{ textTransform: "capitalize" }}
                    onChange={() =>
                      onGrainChanges(ordersToShow[index].order.orderNumber)
                    }
                    disabled={
                      ordersForSelectedPo.data.pos[
                        location.state.selectedPoIndex
                      ].isPOSaved
                        ? true
                        : ordersToShow[index].order.type === "reel"
                        ? true
                        : false
                    }
                  >
                    {["short", "long"].map((grain) => (
                      <Option
                        key={`${grain}${ordersToShow[index].order.orderNumber}`}
                        value={grain}
                      >
                        {grain}
                      </Option>
                    ))}{" "}
                    */
                  </Select>
                </Form.Item>
              </div>
              {ordersToShow[index].errors.hasOwnProperty("grain") &&
              ordersToShow[index].order.type === "sheet" ? (
                <span className="errorText" style={{ color: "#ea4e2c" }}>
                  {ordersToShow[index].errors.grain}
                </span>
              ) : null}
            </Col>
          )}
          {isVisible && (
            <Col>
              {index == 0 && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    padding: "2px 0px 6px 5px",
                  }}
                >
                  <span
                    className="columnHeader"
                    style={{ verticalAlign: "bottom", display: "contents" }}
                  >
                    Grain Settings
                  </span>
                </div>
              )}
              <div className="boxFormType">
                <Form.Item
                  name={`grainChanges${ordersToShow[index].order.orderNumber}`}
                >
                  <GlobalSet>
                    <div
                      className="checklist-address"
                      style={{ paddingTop: "0px" }}
                    >
                      <Checkbox
                        type="checkbox"
                        onChange={(e) =>
                          onGrainChangesChange(
                            e,
                            ordersToShow[index].order.orderNumber
                          )
                        }
                        checked={
                          ordersToShow[index].order.rotaion ? true : false
                        }
                        disabled={
                          ordersForSelectedPo.data.pos[
                            location.state.selectedPoIndex
                          ].isPOSaved
                            ? true
                            : ordersToShow[index].order.type === "reel"
                            ? true
                            : false
                        }
                      />
                      <p
                        style={{
                          fontSize: "14px",
                          fontStyle: "normal",
                          lineHeight: "20px",
                          fontFamily: "var(--sf-pro-text)",
                          color: "var(--para-text)",
                          margin: "0",
                          marginTop: "-7px",
                        }}
                      >
                        Allow grain changes
                      </p>
                    </div>
                  </GlobalSet>
                </Form.Item>
              </div>
              <div className="boxFormType">
                <Form.Item
                  name={`grainMixing${ordersToShow[index].order.orderNumber}`}
                >
                  <GlobalSet>
                    <div
                      className="checklist-address"
                      style={{ marginTop: "-32px" }}
                    >
                      <Checkbox
                        type="checkbox"
                        onChange={(e) =>
                          onGrainMixingChange(
                            e,
                            ordersToShow[index].order.orderNumber
                          )
                        }
                        checked={
                          ordersToShow[index].order.grain_mixing ? true : false
                        }
                        disabled={
                          !defaultMixedGrain ||
                          (ordersForSelectedPo.data.pos[
                            location.state.selectedPoIndex
                          ].isPOSaved
                            ? true
                            : ordersToShow[index].order.type === "reel"
                            ? true
                            : false)
                        }
                      />
                      <p
                        style={{
                          fontSize: "14px",
                          fontStyle: "normal",
                          lineHeight: "20px",
                          fontFamily: "var(--sf-pro-text)",
                          color: "var(--para-text)",
                          margin: "0",
                          marginTop: "-5px",
                        }}
                      >
                        Allow mixed grain
                      </p>
                    </div>
                    {ordersToShow[index].order.type === "sheet" &&
                      !defaultMixedGrain && (
                        <p
                          style={{
                            fontSize: "13px",
                            fontStyle: "normal",
                            lineHeight: "20px",
                            fontFamily: "var(--sf-pro-text)",
                            color: "var(--para-text)",
                            fontStyle: "italic",
                            marginTop: "-20px",
                            marginRight: "40px",
                          }}
                        >
                          Disabled in Config
                        </p>
                      )}
                  </GlobalSet>
                </Form.Item>
              </div>
            </Col>
          )}

          <Col style={{ width: "140px" }}>
            {index == 0 && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  padding: "2px 0px 6px 5px",
                }}
              >
                <div className="mandatorySymbolColumnHeader">*</div>
                <div>
                  <span className="columnHeader">Order Weight</span>
                  <Styled style={{ display: "inline-flex" }}>
                    <Tooltip
                      placement="bottomRight"
                      title={
                        "Either Order weight or quantity should be present. If both are present, order weight will be considered."
                      }
                      className="edit-tooltip"
                      getPopupContainer={(triggerNode) => triggerNode}
                    >
                      <span className="infoIcon"></span>
                    </Tooltip>
                  </Styled>
                </div>
              </div>
            )}
            <div className="boxFormType">
              <Form.Item
                name={`orderWeight${ordersToShow[index].order.orderNumber}`}
                rules={[
                  {
                    required:
                      ordersToShow[index].order.quantity_type == "weight"
                        ? true
                        : false,
                    message: "This field is required",
                  },
                  // {
                  //   pattern: ordersToShow[index].order.quantity_type == "weight" ? (new RegExp(
                  //     /^\d+(\.\d{0,3})?$/
                  //   )) : (""),
                  //   message:
                  //     "This value should be a non-zero positive value",
                  // },
                  // {
                  //     pattern: ordersToShow[index].order.quantity_type == "weight" ? (new RegExp(
                  //     /^(?!0+(\.0+)?$)\d+(\.\d+)?$/
                  //     )) : (""),
                  //     message:
                  //     "Weight should be a number greater than zero",
                  // },
                ]}
                className="dBlock"
                initialValue={ordersToShow[index].order.weight}
              >
                <Input
                  placeholder="Enter weight"
                  onChange={() =>
                    onOrderWeightChange(ordersToShow[index].order.orderNumber)
                  }
                  style={{ textTransform: "capitalize" }}
                  disabled={
                    ordersForSelectedPo.data.pos[location.state.selectedPoIndex]
                      .isPOSaved
                      ? true
                      : false
                  }
                />
              </Form.Item>
            </div>
            {ordersToShow[index].errors.hasOwnProperty("weight") ? (
              <span className="errorText" style={{ color: "#ea4e2c" }}>
                {ordersToShow[index].errors.weight}
              </span>
            ) : null}
          </Col>
          <Col style={{ width: "140px" }}>
            <div className="boxFormType unitSelect">
              <Form.Item
                label={index == 0 ? "Unit" : ""}
                name={`orderWeightUnit${ordersToShow[index].order.orderNumber}`}
                rules={[
                  {
                    required:
                      !ordersToShow[index].order.weight &&
                      !ordersToShow[index].order.no_of_reel_sheet
                        ? true
                        : ordersToShow[index].order.weight
                        ? true
                        : false,
                    message: "This field is required",
                  },
                ]}
                className="dBlock"
                initialValue={ordersToShow[index].order.weight_unit}
              >
                <Select
                  placeholder="Unit"
                  suffixIcon={<DownArrowDraw />}
                  className="dBlock"
                  style={{ textTransform: "capitalize" }}
                  onChange={() =>
                    onOrderWeightUnitChange(
                      ordersToShow[index].order.orderNumber
                    )
                  }
                  disabled={
                    ordersForSelectedPo.data.pos[location.state.selectedPoIndex]
                      .isPOSaved
                      ? true
                      : false
                  }
                >
                  {weightUnitList?.map((unit) => (
                    <Option
                      key={`${unit}${ordersToShow[index].order.orderNumber}`}
                      value={unit}
                    >
                      {capitalize(weightUnit[unit]?.displayName)}
                    </Option>
                  ))}{" "}
                  */
                </Select>
              </Form.Item>
            </div>
            {ordersToShow[index].errors.hasOwnProperty("weight_unit") ? (
              <span className="errorText" style={{ color: "#ea4e2c" }}>
                {ordersToShow[index].errors.weight_unit}
              </span>
            ) : null}
          </Col>
          <Col style={{ width: "140px" }}>
            {index == 0 && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  padding: "2px 0px 6px 5px",
                }}
              >
                <div className="mandatorySymbolColumnHeader">*</div>
                <div>
                  <span className="columnHeader">Quantity</span>
                  <Styled style={{ display: "inline-flex" }}>
                    <Tooltip
                      placement="bottomRight"
                      title={
                        "It represents number of reel or sheets. Either order weight or quantity should be present. If both are present, order weight will be considered."
                      }
                      className="edit-tooltip"
                      getPopupContainer={(triggerNode) => triggerNode}
                    >
                      <span className="infoIcon"></span>
                    </Tooltip>
                  </Styled>
                </div>
              </div>
            )}
            <div className="boxFormType">
              <Form.Item
                name={`quantity${ordersToShow[index].order.orderNumber}`}
                rules={[
                  {
                    required: true,
                    message: "This field is required",
                  },
                ]}
                className="dBlock"
                initialValue={ordersToShow[index].order.no_of_reel_sheet}
              >
                <Input
                  placeholder={savedState ? "Enter quantity" : ""}
                  onChange={() =>
                    onQuantityChange(ordersToShow[index].order.orderNumber)
                  }
                  // style={{ textTransform: "capitalize" }}
                  disabled={
                    ordersForSelectedPo.data.pos[location.state.selectedPoIndex]
                      .isPOSaved
                      ? true
                      : false
                  }
                />
              </Form.Item>
            </div>
            {ordersToShow[index].errors.hasOwnProperty("no_of_reel_sheet") ? (
              <span className="errorText" style={{ color: "#ea4e2c" }}>
                {ordersToShow[index].errors.no_of_reel_sheet}
              </span>
            ) : null}
          </Col>
          {!location.state.isSOOrders && (
            <>
              <Col style={{ width: "103px" }}>
                <div className="boxFormType unitSelect">
                  <Form.Item
                    label={index == 0 ? "Currency" : ""}
                    name={`currency${ordersToShow[index].order.orderNumber}`}
                    rules={[
                      {
                        required: parseFloat(
                          ordersToShow[index].order.dealer_price
                        )
                          ? true
                          : false,
                        message: "This field is required",
                      },
                    ]}
                    className="dBlock"
                    initialValue={
                      ordersToShow[index].order.currency
                        ? ordersToShow[index].order.currency
                        : ""
                    }
                  >
                    <Select
                      placeholder="Currency"
                      suffixIcon={<DownArrowDraw />}
                      className="dBlock"
                      style={{ textTransform: "capitalize" }}
                      onChange={() =>
                        onCurrencyChange(ordersToShow[index].order.orderNumber)
                      }
                      disabled={
                        ordersForSelectedPo.data.pos[
                          location.state.selectedPoIndex
                        ].isPOSaved
                          ? true
                          : false
                      }
                    >
                      {currencyUnitData?.map((currencyUnit) => (
                        <Option
                          key={currencyUnit.code}
                          value={currencyUnit.code}
                        >
                          {/* {currencyUnit.displayName} */}
                          <Tooltip title={currencyUnit.displayName}>
                            {`${currencyUnit.code}`}
                          </Tooltip>
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>
                {ordersToShow[index].errors.hasOwnProperty("currency") ? (
                  <span className="errorText" style={{ color: "#ea4e2c" }}>
                    {ordersToShow[index].errors.currency}
                  </span>
                ) : null}
              </Col>
              <Col style={{ width: "164px" }}>
                <div className="boxFormType">
                  <Form.Item
                    label={index == 0 ? "Dealer's price/ weight" : ""}
                    name={`price${ordersToShow[index].order.orderNumber}`}
                    rules={[
                      // {
                      //   required: true,
                      //   message: "This field is required",
                      // }
                      {
                        pattern: new RegExp(/^\d+(\.\d+)?$/),
                        message: "Only decimal values possible",
                      },
                    ]}
                    className="dBlock"
                    initialValue={ordersToShow[index].order.dealer_price}
                  >
                    <Input
                      placeholder="Enter price"
                      onChange={() =>
                        onPriceChange(ordersToShow[index].order.orderNumber)
                      }
                      // style={{ textTransform: "capitalize" }}
                      disabled={
                        ordersForSelectedPo.data.pos[
                          location.state.selectedPoIndex
                        ].isPOSaved
                          ? true
                          : false
                      }
                    />
                  </Form.Item>
                </div>
                {ordersToShow[index].errors.hasOwnProperty("dealer_price") ? (
                  <span className="errorText" style={{ color: "#ea4e2c" }}>
                    {ordersToShow[index].errors.dealer_price}
                  </span>
                ) : null}
              </Col>
              <Col style={{ width: "185px" }}>
                <div className="boxFormType">
                  <Form.Item
                    label={index == 0 ? "Customer's price/ weight" : ""}
                    name={`customerPrice${ordersToShow[index].order.orderNumber}`}
                    rules={[
                      // {
                      //   required: true,
                      //   message: "This field is required",
                      // }
                      {
                        pattern: new RegExp(/^\d+(\.\d+)?$/),
                        message: "Only decimal values possible",
                      },
                    ]}
                    className="dBlock"
                    initialValue={ordersToShow[index].order.customer_price}
                  >
                    <Input
                      placeholder="Enter price"
                      onChange={() =>
                        onCustPriceChange(ordersToShow[index].order.orderNumber)
                      }
                      style={{ textTransform: "capitalize" }}
                      disabled={
                        ordersForSelectedPo.data.pos[
                          location.state.selectedPoIndex
                        ].isPOSaved
                          ? true
                          : false
                      }
                    />
                  </Form.Item>
                </div>
                {ordersToShow[index].errors.hasOwnProperty("customer_price") ? (
                  <span className="errorText" style={{ color: "#ea4e2c" }}>
                    {ordersToShow[index].errors.customer_price}
                  </span>
                ) : null}
              </Col>
              {/* {index == 0 && <span style={{marginLeft:"1px", marginRight:"-10px"}}>  /  </span>} */}
              <Col
                style={{
                  marginTop: index == 0 ? "40px" : "9px",
                  paddingLeft: index == 0 ? "7px" : "5px",
                }}
              >
                {" "}
                /{" "}
              </Col>
              <Col style={{ width: "160px" }}>
                <div className="boxFormType">
                  <Form.Item
                    label={index == 0 ? "Weight unit of price" : ""}
                    name={`per_weight_unit${ordersToShow[index].order.orderNumber}`}
                    rules={[
                      {
                        required:
                          parseFloat(ordersToShow[index].order.dealer_price) ||
                          parseFloat(ordersToShow[index].order.customer_price)
                            ? true
                            : false,
                        message: "This field is required",
                      },
                    ]}
                    className="dBlock"
                    initialValue={
                      ordersToShow[index].order.per_weight_unit
                        ? ordersToShow[index].order.per_weight_unit
                        : ""
                    }
                  >
                    <Select
                      placeholder="Weight unit of price"
                      suffixIcon={<DownArrowDraw />}
                      className="dBlock"
                      // style={{ textTransform: "capitalize" }}
                      onChange={() =>
                        onWeightUnitChange(
                          ordersToShow[index].order.orderNumber
                        )
                      }
                      disabled={
                        ordersForSelectedPo.data.pos[
                          location.state.selectedPoIndex
                        ].isPOSaved
                          ? true
                          : false
                      }
                    >
                      {weightUnitList?.map((item) => (
                        <Option key={item} value={item}>
                          {capitalize(weightUnit[item]?.displayName)}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>
                {ordersToShow[index].errors.hasOwnProperty(
                  "per_weight_unit"
                ) ? (
                  <span className="errorText" style={{ color: "#ea4e2c" }}>
                    {ordersToShow[index].errors.per_weight_unit}
                  </span>
                ) : null}
              </Col>
            </>
          )}
          <Col style={{ width: "170px" }}>
            <div className="boxFormType">
              {ordersToShow[index].order.type == "reel" ? (
                <Form.Item
                  label={index == 0 ? "Packaging Type" : ""}
                  name={`packagingType${ordersToShow[index].order.orderNumber}`}
                  rules={[]}
                  className="dBlock"
                  initialValue={
                    ordersToShow[index].order.packaging_details?.id
                      ? ordersToShow[
                          index
                        ].order.packaging_details?.id?.toString()
                      : ""
                  }
                >
                  <Select
                    placeholder="Select Packaging"
                    suffixIcon={<DownArrowDraw />}
                    showSearch
                    optionFilterProp="children"
                    onChange={(e) =>
                      onPackagingChange(
                        ordersToShow[index].order.orderNumber,
                        e
                      )
                    }
                    disabled={
                      ordersForSelectedPo.data.pos[
                        location.state.selectedPoIndex
                      ].isPOSaved
                        ? true
                        : false
                    }
                  >
                    {reelPackagingData.length &&
                      reelPackagingData?.map((item) => (
                        <Option value={item.id.toString()} key={item.id}>
                          {item.name} -{" "}
                          {item.quantity_type === "weight"
                            ? item.weight +
                              " " +
                              (item.units && item.units.weight
                                ? capitalize(
                                    weightUnit[item.units.weight]?.displayName
                                  )
                                : "")
                            : item.quantity + " " + capitalize(item.type) + "s"}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              ) : (
                <Form.Item
                  label={index == 0 ? "Packaging Type" : ""}
                  name={`packagingType${ordersToShow[index].order.orderNumber}`}
                  rules={[]}
                  className="dBlock"
                  initialValue={
                    ordersToShow[index].order.packaging_details?.id
                      ? ordersToShow[
                          index
                        ].order.packaging_details?.id?.toString()
                      : ""
                  }
                >
                  <Select
                    placeholder="Select Packaging"
                    suffixIcon={<DownArrowDraw />}
                    showSearch
                    optionFilterProp="children"
                    onChange={(e) =>
                      onPackagingChange(
                        ordersToShow[index].order.orderNumber,
                        e
                      )
                    }
                    disabled={
                      ordersForSelectedPo.data.pos[
                        location.state.selectedPoIndex
                      ].isPOSaved
                        ? true
                        : false
                    }
                  >
                    {sheetPackagingData.length &&
                      sheetPackagingData?.map((item) => (
                        <Option value={item.id.toString()} key={item.id}>
                          {item.name} -{" "}
                          {item.quantity_type === "weight"
                            ? item.weight +
                              " " +
                              (item.units && item.units.weight
                                ? capitalize(
                                    weightUnit[item.units.weight]?.displayName
                                  )
                                : "")
                            : item.quantity + " " + capitalize(item.type) + "s"}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              )}
            </div>
            {ordersToShow[index].errors.hasOwnProperty("packaging_details") ? (
              <span className="errorText" style={{ color: "#ea4e2c" }}>
                {ordersToShow[index].errors.packaging_details}
              </span>
            ) : null}
          </Col>
          {!location.state.isSOOrders && (
            <>
              <Col style={{ width: "140px" }}>
                <DatePickerY>
                  <Form.Item
                    label={index == 0 ? "Delivery Date" : ""}
                    name={`deliveryDate${ordersToShow[index].order.orderNumber}`}
                    rules={[
                      {
                        required: true,
                        message: "This field is required",
                      },
                    ]}
                    className="dBlock"
                    initialValue={
                      ordersToShow[index].errors.hasOwnProperty(
                        "delivery_date"
                      ) ||
                      ordersToShow[index].order.delivery_date ===
                        "Invalid date" ||
                      ordersToShow[index].order.delivery_date === "" ||
                      ordersForSelectedPo.data.pos[
                        location.state.selectedPoIndex
                      ].errors.hasOwnProperty("delivery_date") ||
                      !moment(ordersToShow[index].order.delivery_date, moment.ISO_8601, true).isValid()

                        ? ""
                        : moment(ordersToShow[index].order.delivery_date)
                    }
                  >
                    <DatePicker
                      placeholder="Select date"
                      format={"DD/MM/YYYY"}
                      
                      disabledDate={(current) => {
                        return current && current < moment().subtract(1, "day");
                      }}
                      onChange={(date) =>
                        onDeliveryDateChange(
                          ordersToShow[index].order.orderNumber,date
                        )
                      }
                      disabled={
                        ordersForSelectedPo.data.pos[
                          location.state.selectedPoIndex
                        ].isPOSaved
                          ? true
                          : false
                      }
                    />
                  </Form.Item>
                </DatePickerY>
                {ordersForSelectedPo.data.pos[
                  location.state.selectedPoIndex
                ].errors.hasOwnProperty("delivery_date") ||
                ordersToShow[index].errors.hasOwnProperty("delivery_date") ? (
                  <span className="errorText" style={{ color: "#ea4e2c" }}>
                    {ordersForSelectedPo.data.pos[
                      location.state.selectedPoIndex
                    ].errors.hasOwnProperty("delivery_date")
                      ? ordersForSelectedPo.data.pos[
                          location.state.selectedPoIndex
                        ].errors.delivery_date
                      : ordersToShow[index].errors.delivery_date}
                  </span>
                ) : (
                  !moment(ordersToShow[index].order.delivery_date, moment.ISO_8601, true).isValid()
&& (
                    <span className="errorText" style={{ color: "#ea4e2c" }}>
                      {ordersToShow[index].order.delivery_date} is not a valid
                      date
                    </span>
                  )
                )}
              </Col>
            </>
          )}
          <Col style={{ width: "260px" }}>
            <div className="boxFormType">
              <Form.Item
                label={index == 0 ? "Remarks" : ""}
                name={`remark${ordersToShow[index].order.orderNumber}`}
                className="dBlock"
                initialValue={ordersToShow[index].order.remarks}
              >
                <Input
                  placeholder="Enter Remark"
                  onChange={() =>
                    onRemarkChange(ordersToShow[index].order.orderNumber)
                  }
                  // style={{ textTransform: "capitalize" }}
                  disabled={
                    ordersForSelectedPo.data.pos[location.state.selectedPoIndex]
                      .isPOSaved
                      ? true
                      : false
                  }
                />
              </Form.Item>
            </div>
          </Col>
          <Col style={{ width: "260px" }}>
            <div className="boxFormType">
              <Form.Item
                label={index == 0 ? "Reel OD" : ""}
                className="dBlock"
                name={`reel_OD${ordersToShow[index].order.orderNumber}`}
                rules={[
                  // {
                  //   required: true,
                  //   message: "This field is required",
                  // },
                  // {
                  //   validator: (_, value) => {
                  //     if(reelError){
                  //       return Promise.reject(new Error('Core OD should be less than Reel OD'));
                  //     }
                  //     return Promise.resolve();
                  //   }
                  // }
                  {
                    validator: (_, value) => {
                      const coreODFieldValue = form.getFieldValue(`core_OD${ordersToShow[index].order.orderNumber}`);
                      
                      if (!value?.trim() || !coreODFieldValue?.trim()) return Promise.resolve();

                      const coreParts = String(coreODFieldValue).trim().split(/\s+/);
                      const reelParts = String(value).trim().split(/\s+/);

                      let coreConv = orderDim_Rewinder_Unit_Conversion[coreParts[1]];
                      let reelConv = orderDim_Rewinder_Unit_Conversion[reelParts[1]];

                      let coreVal = (parseFloat(coreParts[0]) || 0) * (coreConv ?? 0);
                      let reelVal = (parseFloat(reelParts[0]) || 0) * (reelConv ?? 0);

                      if (coreVal > reelVal) {
                        return Promise.reject(new Error("Core OD should be less than Reel OD"));
                      }

                      return Promise.resolve();
                    }
                  }
                ]}
                initialValue={(ordersToShow[index]?.order?.reel_od ? ordersToShow[index]?.order?.reel_od : "") + " " + (ordersToShow[index]?.order?.reel_od ? ordersToShow[index]?.order?.reel_od_unit : "")}
              >
                <Select
                  placeholder="Select Reel OD"
                  suffixIcon={<DownArrowDraw />}
                  showSearch
                  optionFilterProp="children"
                  className="dBlock"
                  onChange={(value) => {
                        form.setFieldsValue({
                          [`reel_OD${ordersToShow[index].order.orderNumber}`]: value,
                        });

                        const coreValue = form.getFieldValue(`core_OD${ordersToShow[index].order.orderNumber}`);

                        onReelODChange(ordersToShow[index].order.orderNumber, value)

                        if (!value || !coreValue) return;

                        const coreParts = String(coreValue).trim().split(/\s+/);
                        const reelParts = String(value).trim().split(/\s+/);

                        let coreConv = orderDim_Rewinder_Unit_Conversion[coreParts[1]];
                        let reelConv = orderDim_Rewinder_Unit_Conversion[reelParts[1]];

                        let coreVal = (parseFloat(coreParts[0]) || 0) * (coreConv ?? 0);
                        let reelVal = (parseFloat(reelParts[0]) || 0) * (reelConv ?? 0);

                        if (coreVal <= reelVal) {
                          form.setFields([
                            { name: `core_OD${ordersToShow[index].order.orderNumber}`, errors: [] },
                            { name: `reel_OD${ordersToShow[index].order.orderNumber}`, errors: [] },
                          ]);
                        }
                  }}
                  // style={{ width: "331px" }}
                  disabled={
                    // (props.isEditFromIncompleteOrder && props.type === "deckleRecord") ||
                    // (props.isEditFromIncompleteOrder && !orderMangtSettings?.data?.edit_after_approval?.value)
                    props?.actionType == "view"
                  }
                >
                  {reelvalues?.map((data) => (
                    <Option key={data.value}>{data.value}</Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
            {ordersToShow[index].errors.hasOwnProperty("reel_od") ? (
              <span className="errorText" style={{ color: "#ea4e2c" }}>
                {ordersToShow[index].errors.reel_od}
              </span>
            ) : null}
          </Col>
          <Col style={{ width: "260px" }}>
            <div className="boxFormType">
              <Form.Item
                label={index == 0 ? "Core OD" : ""}
                name={`core_OD${ordersToShow[index].order.orderNumber}`}
                rules={[
                  // {
                  //   required: true,
                  //   message: "This field is required",
                  // },
                  // {
                  //   validator: (_, value) => {
                  //     if(coreError){
                  //       return Promise.reject(new Error('Core OD should be less than Reel OD'));
                  //     }
                  //     return Promise.resolve();
                  //   }
                  // }

                  {
                    validator: (_, value) => {
                      const reelODFieldValue = form.getFieldValue(`reel_OD${ordersToShow[index].order.orderNumber}`);

                      if (!value?.trim() || !reelODFieldValue?.trim()) return Promise.resolve();

                      const coreParts = String(value).trim().split(/\s+/);
                      const reelParts = String(reelODFieldValue).trim().split(/\s+/);

                      let coreConv = orderDim_Rewinder_Unit_Conversion[coreParts[1]];
                      let reelConv = orderDim_Rewinder_Unit_Conversion[reelParts[1]];

                      let coreVal = (parseFloat(coreParts[0]) || 0) * (coreConv ?? 0);
                      let reelVal = (parseFloat(reelParts[0]) || 0) * (reelConv ?? 0);

                      if (coreVal > reelVal) {
                        return Promise.reject(new Error("Core OD should be less than Reel OD"));
                      }

                      return Promise.resolve();
                    }
                  }
                ]}
                className="dBlock"
                initialValue={(ordersToShow[index]?.order?.core_id ? ordersToShow[index]?.order?.core_id : "") + " " + (ordersToShow[index]?.order?.core_id ? ordersToShow[index]?.order?.core_id_unit : "")}
              >
                <Select
                  placeholder="Select Core OD"
                  suffixIcon={<DownArrowDraw />}
                  showSearch
                  optionFilterProp="children"
                  onChange={(value) => {
                      form.setFieldsValue({
                        [`core_OD${ordersToShow[index].order.orderNumber}`]: value,
                      });

                      const reelValue = form.getFieldValue(`reel_OD${ordersToShow[index].order.orderNumber}`);

                      onCoreODChange(ordersToShow[index].order.orderNumber, value)

                      if (!value || !reelValue) return;

                      const coreParts = String(value).trim().split(/\s+/);
                      const reelParts = String(reelValue).trim().split(/\s+/);

                      let coreConv = orderDim_Rewinder_Unit_Conversion[coreParts[1]];
                      let reelConv = orderDim_Rewinder_Unit_Conversion[reelParts[1]];

                      let coreVal = (parseFloat(coreParts[0]) || 0) * (coreConv ?? 0);
                      let reelVal = (parseFloat(reelParts[0]) || 0) * (reelConv ?? 0);

                      // ✅ VALID → CLEAR ERRORS
                      if (coreVal <= reelVal) {
                        form.setFields([
                          { name: `core_OD${ordersToShow[index].order.orderNumber}`, errors: [] },
                          { name: `reel_OD${ordersToShow[index].order.orderNumber}`, errors: [] },
                        ]);
                      }
                  }}
                  // style={{ width: "331px" }}
                  disabled={
                    // (props.isEditFromIncompleteOrder && props.type === "deckleRecord") ||
                    // (props.isEditFromIncompleteOrder && !orderMangtSettings?.data?.edit_after_approval?.value)
                    props?.actionType == "view"
                  }
                >
                  {corevalues?.map((data) => (
                    <Option key={data.value}>{data.value}</Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
            {ordersToShow[index].errors.hasOwnProperty("core_id") ? (
              <span className="errorText" style={{ color: "#ea4e2c" }}>
                {ordersToShow[index].errors.core_id}
              </span>
            ) : null}
          </Col>

          {setRowCount()}
        </Row>
      </div>
    );

  return filteredOrders ? (
    <RightLayoutContainer>
      <PageTitleComp
        className="marginRightAdg"
        style={{ marginBottom: "12px" }}
      >
        <PageHeader
          title="Uploaded Summary"
          extra={[
            <Button
              key="3"
              className="themeBtn noBg"
              loading={gobackLoading}
              onClick={() => goBack()}
              disabled={otherButtonLoading || resendAppOtherButtonLoading}
            >
              {!gobackLoading && (
                <Iconmoon icon="left-to-thin" size={14} color="#EA655B" />
              )}
              {!gobackLoading ? "Go Back" : ""}
            </Button>,
            <Button
              key="1"
              className="themeBtn noBg"
              onClick={() => saveDetails("open")}
              loading={loadings}
              disabled={
                savedState ||
                !products?.length ||
                (!ordersForSelectedPo &&
                  Object.keys(
                    ordersForSelectedPo.data.pos[location.state.selectedPoIndex]
                      .orders
                  ).length != 0) ||
                (ordersForSelectedPo.data.pos[location.state.selectedPoIndex]
                  .error_count != 0 &&
                  Object.keys(
                    ordersForSelectedPo.data.pos[location.state.selectedPoIndex]
                      .errors
                  ).length != 0) ||
                !ordersForSelectedPo.data.pos[location.state.selectedPoIndex].po
                  .delivery_address_line_1 ||
                !ordersForSelectedPo.data.pos[location.state.selectedPoIndex].po
                  .delivery_state ||
                !ordersForSelectedPo.data.pos[location.state.selectedPoIndex].po
                  .delivery_city ||
                !ordersForSelectedPo.data.pos[location.state.selectedPoIndex].po
                  .delivery_pincode ||
                !ordersForSelectedPo.data.pos[location.state.selectedPoIndex].po
                  .delivery_country ||
                !ordersForSelectedPo.data.pos[location.state.selectedPoIndex].po
                  .shipping_address_line_1 ||
                !ordersForSelectedPo.data.pos[location.state.selectedPoIndex].po
                  .shipping_state ||
                !ordersForSelectedPo.data.pos[location.state.selectedPoIndex].po
                  .shipping_city ||
                !ordersForSelectedPo.data.pos[location.state.selectedPoIndex].po
                  .shipping_pincode ||
                !ordersForSelectedPo.data.pos[location.state.selectedPoIndex].po
                  .shipping_country ||
                !ordersForSelectedPo.data.pos[location.state.selectedPoIndex].po
                  .billing_address_line_1 ||
                !ordersForSelectedPo.data.pos[location.state.selectedPoIndex].po
                  .billing_state ||
                !ordersForSelectedPo.data.pos[location.state.selectedPoIndex].po
                  .billing_city ||
                !ordersForSelectedPo.data.pos[location.state.selectedPoIndex].po
                  .billing_pincode ||
                !ordersForSelectedPo.data.pos[location.state.selectedPoIndex].po
                  .billing_country ||
                (ordersForSelectedPo.data.pos[
                  location.state.selectedPoIndex
                ].orders.filter((e) => e.error_count > 0).length == 0
                  ? ordersForSelectedPo.data.pos[location.state.selectedPoIndex]
                      .isPOSaved
                    ? true
                    : false
                  : true) ||
                resendAppOtherButtonLoading
              }
            >
              {!loadings && (
                <Iconmoon icon="addcircle" size={14} color="#EA655B" />
              )}
              {!loadings ? "Save Details" : ""}
            </Button>,
            <Button
              key="2"
              className="themeBtn"
              onClick={() => saveDetails("pending")}
              loading={resendAppLoading}
              disabled={
                savedState ||
                !products?.length ||
                (ordersForSelectedPo.data.pos[location.state.selectedPoIndex]
                  .error_count == 0 &&
                Object.keys(
                  ordersForSelectedPo.data.pos[location.state.selectedPoIndex]
                    .errors
                ).length == 0 &&
                ordersForSelectedPo.data.pos[
                  location.state.selectedPoIndex
                ].orders.filter((e) => e.error_count > 0).length == 0
                  ? ordersForSelectedPo.data.pos[location.state.selectedPoIndex]
                      .isPOSaved
                    ? true
                    : false
                  : true) ||
                otherButtonLoading
              }
            >
              {!resendAppLoading && (
                <Iconmoon icon="addcircle" size={14} color="#ffffff" />
              )}
              {!resendAppLoading ? "Save & Send for Approval" : ""}
            </Button>,
          ]}
        ></PageHeader>
      </PageTitleComp>

      <div
        className="showPriorityOrder"
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "10px",
        }}
      >
        <div
          style={{
            marginTop: "10px",
            fontSize: "14px",
            fontFamily: "var(--sf-pro-display)",
            lineHeight: "16px",
          }}
        >
          {location.state.isSOOrders ? "SO" : "PO"}:{" "}
          {
            ordersForSelectedPo.data.pos[location.state.selectedPoIndex].po
              .number
          }
        </div>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <div>
            <DisabledButtonStyle style={{ displayFlex: "end" }}>
              <Button
                className={
                  show
                    ? "themeBtn noBg approveAllOrders"
                    : "themeBtn noBg disabledstyle approve-header"
                }
                onClick={() => {
                  setShow(!show);
                  filterRecords(!show);
                  rowCount.current = false;
                }}
              >
                <Iconmoon icon="filter" size={16} color="#605E5C" />{" "}
                {show ? "Show All Orders" : "Show Only Failed Orders"}
              </Button>
            </DisabledButtonStyle>
          </div>
          <div
            style={{
              marginTop: "10px",
              marginRight: "15px",
              fontSize: "14px",
              fontFamily: "var(--sf-pro-display)",
              lineHeight: "16px",
            }}
          >
            Failed Orders:{" "}
            {
              ordersForSelectedPo.data.pos[
                location.state.selectedPoIndex
              ].orders.filter((e) => e.error_count > 0).length
            }
          </div>
          <div
            style={{
              marginTop: "10px",
              fontSize: "14px",
              fontFamily: "var(--sf-pro-display)",
              lineHeight: "16px",
            }}
          >
            Verified Orders:{" "}
            {
              ordersForSelectedPo.data.pos[
                location.state.selectedPoIndex
              ].orders.filter((e) => e.error_count == 0).length
            }
          </div>
        </div>
      </div>
      <OrderSummary>
        <div
          className="orderSummaryStyle"
          style={{ display: "flex", justifyContent: "flex-end", width: "100%" }}
        >
          <div style={{ maxWidth: "410px", marginRight: "1%" }}>
            <span
              className="orderWeightStyle"
              style={{ textAlign: "left", fontStyle: "italic" }}
            >
              Note: The default tolerance +{upperTolerance} to -{lowerTolerance}{" "}
              defined in settings will be used to set tolerance values for
              orders
            </span>
          </div>
        </div>
      </OrderSummary>
      <DetailFields>
        <HaberForm>
          <div className="groupDetailWrap">
            <Form
              form={form}
              name="basic"
              autoComplete="off"
              className="haberLogin"
              onFinish={onFinish}
            >
              <div
                style={{
                  overflow: "auto",
                  width: window.screen.width < 1500 ? "103.5%" : "102%",
                  height: window.screen.width > 1400 ? "600px" : "400px",
                }}
              >
                <AutoSizer>
                  {({ height, width }) => (
                    <FixedSizeList
                      height={height}
                      itemCount={ordersToShow?.length}
                      itemSize={120}
                      width={width}
                      overscanCount={2}
                      onScroll={handleScroll}
                    >
                      {RowData}
                    </FixedSizeList>
                  )}
                </AutoSizer>
                {loading && (
                  <div style={{ position: "relative" }}>
                    <div style={{ marginTop: "33%", marginLeft: "2%" }}>
                      {"Loading..."}
                    </div>
                  </div>
                )}
                {/* <Pagination
                    total={filteredOrders?.length}
                    showTotal={(total, range) => `Showing ${range[0]}-${range[1]} of ${total} results`}
                    defaultPageSize={25}
                    defaultCurrent={currentPage}
                    onChange={onPageChange}
                    showSizeChanger={false}
                  /> */}
              </div>
            </Form>
          </div>
        </HaberForm>
      </DetailFields>
      {/* Toasters */}

      {visibleToaster && !actionToaster.error && (
        <AlertContainer
          color="green toaster"
          icon={alertGreen}
          msg={actionToaster.msg}
        />
      )}
      {visibleToaster && actionToaster.error && (
        <AlertContainer
          color="red toaster"
          icon={alertRed}
          msg={actionToaster.msg}
        />
      )}
    </RightLayoutContainer>
  ) : null;
};
export default UploadedOrdersData;
